{
  "Test": "Test",
  "FEATURES": "Features",
  "CHECKIN": "CheckIn",
  "CALENDAR": "Calendar",
  "MYREGISTRATIONS": "My reservations",
  "PROFILE": "Profile",
  "WELCOME": "Welcome",
  "LOGOUT": "logout ?",
  "MAINMENU": "Main Menu",
  "CATEGORIES": "Ministries",
  "LOCATIONS": "Locations",
  "POLICIES": "Policies",
  "SERVICES": "Services",
  "MEMBERSHIP_REQUESTS": "Membership Requests",
  "PERMISSIONS": "Permissions",
  "PROFILES": "Profiles",
  "ATTENDANCE": "Attendance",
  "EVENTS": "Events",
  "COMMUNICATION": "Communication",
  "SHOWHIDDEN": "Show Hidden",
  "NAME": "Name",
  "DESCRIPTION": "Description",
  "ADDCATEGORY": "Add New Ministry",
  "ADDLOCATION": "Add New Location",
  "ACTIVE_REG_LIMIT": "Active Registration Limit",
  "REG_LIMIT_PERIOD": "Registration Limit Within Period",
  "OCCURENCE": "Registration Period",
  "SELECT": "Select",
  "DAYS": "Day(s)",
  "MONTHS": "Month(s)",
  "WEEKS": "Week(s)",
  "YEARS": "Year(s)",
  "SAVE_BEFORE_ADD": "This record wasn't saved yet. Please save or delete before creating a new one!",
  "ADDED": "Record(s) successfully added!",
  "UPDATED": "Record successfully updated!",
  "HIDE": "Are you sure you want to hide this record? Click again to hide.",
  "UNHIDE": "Are you sure you want to unhide this record? Click again to unhide.",
  "CALENDAR_POLICY": "Apply policy by calendar",
  "ADDPOLICY": "Add Registration Policy",
  "CATEGORY": "Ministry",
  "LOCATION": "Location",
  "ADDSERVICE": "Add New Service",
  "AGAIN_TO_DELETE": "Are you sure you want to delete this record? Click again to delete.",
  "SELECTDAY": "Please select a day of the week.",
  "SERVICEUPDATE": "Service has been successfully updated!",
  "SERVICEDETAILS": "Service Details",
  "BASICINFORMATION": "Basic Information",
  "NAMEREQUIRED": "Name Required",
  "CATEGORYREQUIRED": "Choose Ministry",
  "SELECTCATEGORY": "Select Ministry",
  "LOCATIONREQUIRED": "Choose Location",
  "SELECTLOCATION": "Select Location",
  "SCHEDULEDETAILS": "Schedule Details",
  "NONE": "None",
  "STARTDATE": "Start Date",
  "NOENDDATE": "No End Date",
  "ENDDATE": "End Date",
  "ALLDAY": "All Day Long",
  "STARTTIME": "Start Time",
  "ENDTTIME": "End Time",
  "INTERVAL": "By Interval (for Confessions)",
  "MINUTES": "Minutes",
  "GREATER_THAN_0": "Value must be greater than 0",
  "RECURRENCE": "Event Recurrence",
  "LOGIN": "Login",
  "CHURCHSERVICES": "Church Services",
  "EMAIL": "Email",
  "PASSWORD": "Password",
  "SIGNUP": "Signup",
  "FORGOTPASSWORD": "Forgot Password?",
  "WELCOMETO": "Welcome to",
  "MEMBER?": "Are you a member of this church?",
  "YES": "Yes",
  "NO": "No",
  "VALIDEMAIL": "Please enter a valid email",
  "VALIDPASSWORD": "Please enter a valid password",
  "LOGINPROG": "Login",
  "ACCOUNTACTIVATED": "Congratulations, your account has been successfully created. Please check your email for activation instructions. When done activating your account, login",
  "HERE": "here.",
  "FIRSTNAME": "First Name",
  "LASTNAME": "Last Name",
  "FIRSTNAME_REQUIRED": "First Name Required",
  "LASTNAME_REQUIRED": "Last Name Required",
  "STREET": "Street",
  "STREET_REQUIRED": "Street Required",
  "CITY": "City",
  "CITY_REQUIRED": "City Required",
  "STATE": "State",
  "STATE_REQUIRED": "State Required",
  "ZIP": "Zip Code",
  "ZIP_REQUIRED": "Zip Code Required",
  "COUNTRY": "Country",
  "CELLPHONE": "Cell Phone",
  "CELLPHONE_REQUIRED": "Cell Phone Required",
  "DOB": "Date of Birth",
  "MARITAL_STATUS": "Social Status",
  "SINGLE": "Single",
  "ENGAGED": "Engaged",
  "MARRIED": "Married",
  "WIDOWED": "Widowed",
  "DIVORCED": "Divorced",
  "MARITAL_STATUS_REQUIRED": "Marital Status Required",
  "GENDER": "Gender",
  "MALE": "Male",
  "FEMALE": "Female",
  "GENDER_REQUIRED": "Gender Required",
  "PASSWORD_RESTRICTIONS": "Min 6 letters, with at least 1 uppercase, 1 lowercase, 1 number",
  "CONFIRM_PASSWORD": "Confirm Password",
  "PASSWORD_MISMATCH": "Password Mismatch",
  "CREATEACCOUNT": "Create Account",
  "CLOSE": "Close",
  "EMAIL_USED": "Email already used!",
  "PHONE_USED": "Phone number already used!",
  "USER_CREATION_ERROR": "Error creating user!",
  "USER_CREATED": "User successfully created!",
  "USER_NOTFOUND": "User not found!",
  "TOKEN_ERROR": "Failed to generate token!",
  "SUBMITTED": "Request successfully submitted!",
  "PASSWORD_RESET": "Password successfully reset!",
  "PASSWORD_RESET_FAILURE": "Failed to reset password!",
  "ACCOUNT_INACTIVE": "Account not activated yet. Check your email or signup again.",
  "VALIDATED": "Validation Completed Successfully!",
  "VALIDATION_ERROR": "Error validating Account. Please signup again!",
  "INVALID_USERPASSWORD": "Invalid Email and/or Password!",
  "SAVE_PASSWORD": "Save Password",
  "PASSWORD_REQUEST": "An email has been sent to you. Please allow it a few minutes then check your inbox or spam folder for any instructions on how to reset your password.",
  "RESET_PASSWORD": "Reset Password",
  "SUBMIT_REQUEST": "Submit Request",
  "APPROVE": "Approve",
  "DENY": "Deny",
  "REVIEW": "Review",
  "PENDING_REQUESTS": "Pending Requests",
  "NODATA": "No data to display",
  "CURRENT_ACCOUNTS": "Current Accounts",
  "NOT_ATTENDED": "Absence",
  "FOR_HOW_LONG": "Period",
  "DAY": "Day",
  "MONTH": "Month",
  "YEAR": "Year",
  "FOREVER": "Forever",
  "SEARCH": "Search",
  "ADVANCED_SEARCH": "Advanced Search",
  "ACCOUNT_TYPE": "Account Type",
  "PRIMARY_ACCOUNT": "Primary Account",
  "HOUSEHOLD_MEMBER": "Household Member",
  "AGE_RANGES": "Age Range(s)",
  "SCHOOL_GRADES": "School Grade(s)",
  "CITIES": "Citi(es)",
  "STATES": "State(s)",
  "ZIPCODES": "Zip Code(s)",
  "MEMBERSHIP": "Membership",
  "MEMBER": "Member",
  "GUEST": "Guest",
  "PROFILE_PICTURE": "Profile Picture",
  "SEARCH_RESULT": "Search Result",
  "INCLUSIVE": "Show Matches",
  "EXCLUSIVE": "Show Mismatches",
  "CLEAR": "Clear",
  "AGE_PLACEHOLDER": "Example: 5-9, 11, 12, 15",
  "GRADE_PLACEHOLDER": "Example: 0, 7-8, 10-12",
  "CITY_PLACEHOLDER": "Example: Arlington, Mclean",
  "STATE_PLACEHOLDER": "Example: VA, DC, MD",
  "ZIP_PLACEHOLDER": "Example 77041-77095, 20124",
  "PREVIOUS": "Previous",
  "NEXT": "Next",
  "TOTAL": "Total",
  "SELECTED": "Selected",
  "FIRSTNAME_SORT": "By first name",
  "LASTNAME_SORT": "By last name",
  "SELECTALL": "Select All",
  "UNSELECTALL": "Reset All",
  "SELECTPAGE": "Select Page",
  "UNSELECTPAGE": "Reset Page",
  "PARTOFNAME": "Type part of the name",
  "START_TYPING_NAME": "Start typing part of the name",
  "TEXT_CHURCH_WIDE": "Send Texts",
  "EMAIL_CHURCH_WIDE": "Send Email Messages",
  "TEXT_INDIVIDUALS": "Text Selected Individuals",
  "EMAIL_INDIVIDUALS": "Email Selected Individuals",
  "PERSONAL_TEXT": "Private text",
  "PERSONAL_EMAIL": "Private email",
  "SEND_MULTIPLE": "Send multiple",
  "TEXTS": "texts",
  "EMAILS": "emails",
  "SEND": "Send",
  "PREVIEW_MODE": "Preview",
  "EDIT_MODE": "Edit",
  "TEMPLATE": "Template",
  "MERGE_TAGS": "Merge Tags",
  "FULLNAME": "Full Name",
  "ALLNAMES": "All Names",
  "ATTENDEES": "Attendees",
  "ABSENTEES": "Absentees",
  "EMAIL_SENT": "All Names",
  "TEXT_SENT": "All Names",
  "EMAILS_SENT": "email(s) successfully scheduled!",
  "TEXTS_SENT": "text(s) successfully scheduled!",
  "ATLEAST_ATTENDEE_ABSENTEE": "This message will get sent to account holders of households which had at least one attendee and one absentee",
  "ATLEAST_ATTENDEE": "This message will get sent to account holders of households which had at least one attendee",
  "ATLEAST_ABSENTEE": "This message will get sent to account holders of households which had at least one absentee",
  "REGISTERED_ATTENDED": "This message will get sent to account holders of all households who registered or showed up in this event",
  "THIS_WILL_SEND_TO": "This action will send messages to",
  "PROCEED?": "Do you want to proceed?",
  "MESSAGES": "messages.",
  "TEMPLATE_SAVED": "Template Successfully Saved!",
  "NEW": "New",
  "SAVE": "Save",
  "CONFIRM": "Confirm",
  "YOUR_MESSAGE": "Your message",
  "TEXT": "Text",
  "PREVIEW": "Preview to Send",
  "TEMPLATE_NAME": "Template Name",
  "ACCOUNT_DETAILS": "Account Details",
  "EDIT_PERMISSIONS": "Edit Permissions",
  "ACCOUNT_HOLDER": "Account Holder",
  "NOT_ACTIVATED": "Not Activated",
  "VERIFY_PHONE": "Click Send Code",
  "SEND_CODE": "Send code",
  "VERIFY": "Verify",
  "MEMBER_DEFINITION": "Members attend this church on a regular Basis.",
  "GUEST_DEFINITION": "Guests are visitors of this church or attend occasionally.",
  "PHONE_VERIFIED": "Phone has been successfully verified. Thank you!",
  "MEMBERSHIP_REQUEST_SUBMITTED": "Membership request submitted",
  "MEMBERSHIP_CANCELLATION_SUBMITTED": "Membership cancellation submitted",
  "PROFILE_UPDATED": "User profile has been successfully updated!",
  "DUPLICATE_INFORMATION": "Duplicate Information",
  "MEMBER_ADDED": "Member successfully added!",
  "MEMBER_UPDATED": "Member successfully updated!",
  "CONFIRM_TO_DELETE": "Click confirm to delete this record",
  "UPDATE_PROFILE": "Update Profile",
  "HOUSEHOLD_MEMBERS": "Household Members",
  "RELATIONSHIP": "Relationship",
  "PRIMARY": "Primary",
  "SPOUSE": "Spouse",
  "CHILD": "Child",
  "SIBLING": "Sibling",
  "PARENT": "Parent",
  "RELATIVE": "Relative",
  "OTHER": "Other",
  "RELATIONSHIP_REQUIRED": "Select relationship",
  "DELETE": "Delete",
  "ADD_HOUSEHOLD_MEMBER": "Add household member",
  "ON": "on",
  "REFRESH": "Click to refresh",
  "SERVICE": "Service",
  "SUN": "SUN",
  "MON": "MON",
  "TUE": "TUE",
  "WED": "WED",
  "THU": "THU",
  "FRI": "FRI",
  "SAT": "SAT",
  "FILL_BLOCKED_SPOTS": "Fill blocked spots",
  "NEW_REGISTRATION": "New Registration",
  "EDIT_REGISTRATION": "Edit Registration",
  "CANCEL_REGISTRATION": "Cancel Registration",
  "CONFIRM_CANCEL_REGISTRATION": "Click confirm to cancel registration",
  "EDIT_EVENT": "Edit Event",
  "CANCEL_EVENT": "Cancel Event",
  "CONFIRM_CANCEL_EVENT": "Type 'Cancel Event' and click confirm to cancel this event. Warning: this action will permanently delete all event's registrations.",
  "AVAILABILITY": "Availability",
  "AVAILABLE": "Available",
  "ONLY": "Only",
  "LEFT": "left",
  "UNAVAILABLE": "Unavailable",
  "ADD_PERMISSION": "Add Permission",
  "ACCOUNT_PERMISSIONS": "Account Permissions",
  "GROUP": "Group",
  "GROUP_REQUIRED": "Select Group",
  "ALL_MEMBERS": "All Members",
  "HISTORY_OF_ACTIVITIES": "History of Activities",
  "DATE": "Date",
  "SELECTDATE": "Select Date",
  "VIEWDETAILS": "Details",
  "EVENTDETAILS": "Event Details",
  "FAMILIES": "Families",
  "REG": "Reg.",
  "ATN": "Atn.",
  "ABS": "Abs.",
  "EVENT_COMMUNICATION": "Event Communication",
  "TEXT_EVENT_WIDE": "Send Text Event-Wide",
  "EMAIL_EVENT_WIDE": "Send Email Event-Wide",
  "BLOCKED_SPOTS": "Number of blocked spots",
  "UPDATE": "Save Changes",
  "ENDDATE_SMALLER_START": "End Date cannot be smaller than Start Date.",
  "CHECKIN_SERVICE": "Check-In Service",
  "BLOCKED": "Blocked",
  "SUBMIT": "Submit",
  "FOR_MEMBERS_ONLY": "For Members Only",
  "READ TERMS": "Read Terms",
  "ALTAR_PARYERS": "Altar Prayers",
  "UPDATE_REGISTRATION": "Update Registration",
  "DEPARTED_SOULS": "Departed Souls",
  "SAVE_AND_CLOSE": "Save and Close",
  "NO_AVAILABILITY": "No Availability",
  "NO_MEMBER_SELECTED": "No Members Selected",
  "MAXIMUM_PER_HOUSEHOLD": "Maximum @X persons allowed per household!",
  "RSVP_REACHED": "Unable to register because the deadline for this event was @X",
  "REGISTRATION_SUCCESSFUL": "Registration Successful: @X member(s) attending!",
  "REGISTRATION_UPDATE_SUCCESSFUL": "Update Successful: @X member(s) attending!",
  "FORWARD_TEXT_MESSAGE": "@X texted the following message: @Y",
  "FORWARD_TEXT_MESSAGE_UNKNOWN": "Line number @X texted the following message: @Y",
  "RECORD_NOT_FOUND": "Record was not found!",
  "CANNOT_SAVE_RECORD": "Error saving record!",
  "CANNOT_ADD_RECORD": "Error adding record!",
  "CANNOT_REMOVE_RECORD": "Error deleting record!",
  "RECORD_DELETED": "Record successfully deleted!",
  "FAIL_TO_SEND_CODE": "Failed to send code. Make sure you have the correct phone number in your profile.",
  "FAILED_TO_VERIFY": "Verification failed! Please try again.",
  "PENDING": "Pending",
  "CHURCH_SERVICES": "Church Services",
  "REGISTRATION_CONFIRMATION": "You have successfully registered @MEMBERS for @SERVICENAME on @DATE at @TIME @LOCATION @ADDRESS",
  "REGISTRATION_CANCELLATION": "Your registration for @SERVICENAME on @DATE at @TIME @LOCATION has been cancelled.",
  "MEMBER_CHECKED_IN": "Error cancelling registration: A member already checked in!",
  "ERROR_ADDING_EXISTS": "Error adding record. Please check if it already exists? or deleted?",
  "ERROR_UPDATING": "Error updating record.",
  "ERROR_DELETING": "Error deleting record.",
  "ERROR_UNDELETING": "Error undeleting record.",
  "USER_UPDATED": "User successfully updated!",
  "CHECKIN_AVAILABILITY_ISSUE": "Check-In Failure: Only @NUMBER Seat(s) Left!",
  "VERIFY_MESSAGE": "@CHURCH - Code: @Code. Valid for 5 minutes.",
  "AGE_AND_YOUNGER": "This registration is limited to age @AGE and younger.",
  "AGE_AND_OLDER": "This registration is limited to age @AGE and older.",
  "AGE_BETWEEN": "This registration is limited to ages @AGE1 - @AGE2 years old.",
  "ONLY_MEN": "Registration open only for men",
  "ONLY_WOMEN": "Registration open only for women",
  "ACTIVE_REGISTRATION_LIMIT": "This user already has @COUNT active registration(s). S/He can register after attending.",
  "USER_ALREADY_REGISTERED": "User already registered for service(s) on @DATES",
  "EVENT_REMINDER": "Dear @NAME, this is a reminder that you have @COUNT member(s) registered for @EVENT on @DATE at @TIME",
  "CANNOT_DELETE": "Failed to delete record!",
  "FILE_SUCCESSFULLY_UPLOADED": "File successfully uploaded",
  "PASSWORD_RESET_NOTIFICATION": "You are receiving this email because you have recently requested to reset your system's password. Please proceed by clicking on the 'Reset Password' button below. Thank you!",
  "PASSWORD_RESET_NOTIFICATION_TITLE": "Password Reset Notification",
  "RESET_PASSWORD_BUTTON": "Password Reset",
  "ACCOUNT_ACTIVATION": "You are receiving this email because you have recently signed up for @ChurchName 's Registration System. Please proceed to activate your account by clicking the below Activate Account button. Thank you!",
  "ACCOUNT_ACTIVATION_TITLE": "Account Activation",
  "ACCOUNT_ACTIVATION_BUTTON": "Account Activation",
  "HELLO_NAME": "Hello @NAME",
  "EDIT_CANCEL_REGISTRATION": "To edit or cancel your registration please click on the below button. Thank you!",
  "CONFIRMATION_NOTICE_TITLE": "Confirmation Notice",
  "CANCELLATION_NOTICE_TITLE": "Cancellation Notice",
  "MESSAGE_FROM_CHURCH": "Message from Church",
  "GOTO_REGISTRATION": "Go to Registrations",
  "MEMBERSHIP_REQUEST": "Membership Request",
  "MEMBERSHIP_REQUEST_BODY": "A request has been received from @USER to assign membership(s) for the following individual(s): @INDIVIDUALS.",
  "OPEN_PROFILE": "Open Profile",
  "MEMBERSHIP_CANCELLATION": "Membership Cancellation Request",
  "MEMBERSHIP_CANCELLATION_BODY": "A request has been received from @USER to cancel membership(s) for the following individual(s): @INDIVIDUALS.",
  "VERIFY_TO_REGISTER": "In order to submit a registration, you first need to verify your cell phone number. Click on Send Code to proceed.",
  "REGISTRATION_POLICY": "Registration Policy",
  "CHOOSE_RECURRENCE": "Choose Recurrence",
  "ONE_TIME": "One Time",
  "DAILY_WEEKLY": "Daily / Weekly",
  "MONTHLY": "Monthy",
  "1MONTH": "1st week of the month",
  "2MONTH": "2nd week of the month",
  "3MONTH": "3rd week of the month",
  "4MONTH": "4th week of the month",
  "LMONTH": "5th week of the month",
  "SUNDAY": "Sunday",
  "MONDAY": "Monday",
  "TUESDAY": "Tuesday",
  "WEDNESDAY": "Wednesday",
  "THURSDAY": "Thursday",
  "FRIDAY": "Friday",
  "SATURDAY": "Saturday",
  "BLACKOUT": "Blackout Dates",
  "REGISTRATION_DETAILS": "Registration Details",
  "CAPACITY": "Capacity",
  "MEMBERS": "Members",
  "HHLIMIT": "Limit per household",
  "SPOTS": "Spots",
  "ACTIVE_EVENTS": "Number of events to show",
  "BLOCK_FOR_ADMIN": "Blocked Spots",
  "RSVP": "RSVP deadline - before event",
  "HOURS": "Hours",
  "AGE_RESTRICTION_MIN": "Min Age (0: no minimum)",
  "AGE_RESTRICTION_MAX": "Max Age (0: no maximum)",
  "ALLOWED_GENDER": "Allowed Gender",
  "ALL": "All",
  "TERMS_TITLE": "Terms title",
  "TERMS_LINK": "Terms link",
  "TERMS_TEXT": "Terms text",
  "DISCLAIMER": "Additional Disclaimer",
  "ALLOW_WALKIN": "Allow walk-in",
  "PRAYER_REQUESTS": "Prayer Requests",
  "EMAIL_REMINDER": "Email Reminder",
  "TEXT_REMINDER": "Text Reminder",
  "HOURS_BEFORE_EVENT": "Hours before event",
  "UPDATE_SERVICE": "Update Service",
  "REFRESH_SERVICE": "Refresh Service",
  "UPDATE_EVENT_MESSAGE": "Some events couldn't be modified/cancelled as they already have existing registrations/checkins. If you still want to cancel any of them you need to explicitly do that from the calendar.",
  "UPDATE_EVENT_MESSAGE_DATES": "Those events are on the following dates: @DATES",
  "HIDE_SERVICE": "Hide Service",
  "ENDTIME": "End Time",
  "SELECT_MEMBER": "Select Member",
  "MEMBER_OF_CHURCH?": "Are you a member of this church?",
  "MEMBERSHIP_LATER": "Setup Membership Later",
  "PROCEED_WITH_LOGIN": "Proceed with login",
  "REQUEST_REVIEW": "Request will be sent for administrator review",
  "AGREE_TO_TERMS": "By checking this box I acknowledge that I have read and agree to the",
  "CLICK_TO_REVIEW": "Privacy Policy",
  "LOOKUP_BY_NAME": "Lookup",
  "SELECT_ATTENDEES": "Select attendees then hit submit",
  "ATTENDANCE_REPORT": "Report",
  "SCAN_CAMERA_TO_CHECKIN": "Scan me to check-in",
  "THANK_YOU": "Thank you",
  "CHECKIN_SUCCESSFUL": "You successfully checked in!",
  "SHOW_USHER": "Please show confirmation to usher.",
  "UNKNOWN": "Unknown",
  "ENTER_PHONE": "Enter Phone #",
  "SIGNUP_NOTIFICATION": "You are receiving this email because you have recently signed up for @CHURCHNAME's System. Please proceed to activate your account by clicking the below Activate Account button. Thank you!",
  "DOB_REQUIRED": "Specify date of birth",
  "NO_AVAILABILITY_WALKIN": "Error: No availability for walkins. You can only check-in registered people.",
  "TAG": "Tag",
  "START_TYPING_NAME_OR_TAG": "Start typing to filter",
  "CONFIRM_COPY_SERVICE": "Are you sure you want to duplicate this service? Click again to confirm.",
  "COPYSERVICE": "Duplicate Service",
  "SHOWHIDDENONLY": "Show hidden only",
  "HH_ABBREV": "HHLimit",
  "WALKIN_ABBREV": "Walkin",
  "REFRESH_ALL_SERVICES": "Refresh All Services",
  "POLICY": "Policy",
  "RSVP_DEADLINE": "Deadline to signup for this event has passed. Sorry for the inconvenience.",
  "READ_TERMS": "Read Terms",
  "NEW_TERMS_MESSAGE": "Please accept the new privacy policy by clicking on the checkbox below.",
  "SMS_CONSUMPTION": "Usage",
  "NOTIFICATION": "Notification",
  "HHLIMIT_EXCEEDED": "Limit of household members exceeded",
  "DEPARTMENTS": "Departments",
  "ADDDEPARTMENT": "Add Department",
  "SUPERGROUPS": "Group Collections",
  "ADDSUPERGROUP": "Add Group Collection",
  "TYPE": "Type",
  "DEPARTMENT": "Department",
  "SUPERGROUP": "Group Collection",
  "GROUPS": "Groups",
  "ADDNEWGROUP": "Add New Group",
  "GROUPDETAILS": "Group Details",
  "HIDE_GROUP": "Hide Group",
  "DEPARTMENTREQUIRED": "Choose Department",
  "SELECTDEPARTMENT": "Select Department",
  "SELECTSUPERGROUP": "Select Super Group",
  "MISSION": "Mission",
  "PUBLIC": "Public",
  "PRIVATE": "Private",
  "VIRTUAL": "Virtual",
  "GROUPTYPE": "Group Type",
  "BYREQUEST": "Join By Request",
  "BYINVITATION": "Send Invitation",
  "REQUEST_QUESTION": "Question Before Joining",
  "AUTOASSIGN": "Auto Assign",
  "AUTOREMOVE": "Auto Remove",
  "PROMOTETOGROUP": "Promote to Group",
  "SELECTGROUP": "Select Group",
  "CANLEAVE": "Member can leave",
  "GROUP_MEMBERS": "Group Members",
  "MORE": "More",
  "LESS": "Less",
  "COMMUNICATION_SCOPE": "Allow members to contact",
  "COMMUNICATION_MEAN": "Contact them by",
  "GROUP_LEADERS_ONLY": "Group Leaders Only",
  "GRP_MEMBERS": "All Group Members",
  "MEMBERS_PRIMARIES": "All Members' Parents",
  "REGISTRATION_ERROR": "An error occurred during this transaction!",
  "UPDATE_PASSWORD": "Change Password",
  "RESET_SUCCESSFUL": "Your password has been successfully reset. Now you should be able to login using your new password. Click ",
  "RESET_SUCCESSFUL_LINK": "here",
  "RESET_SUCCESSFUL_SUFFIX": "to login.",
  "ADDTOGROUP": "Join",
  "REMOVEFROMGROUP": "Leave",
  "SETLEADER": "Lead",
  "UNSETLEADER": "Unlead",
  "SUCCESS": "The operation completed successfully",
  "REMOVED": "Record(s) successfully removed!",
  "SHOWGROUP_MEMBERS": "Members",
  "START_TYPING_GMN": "Type 'Leader', 'Requested', 'Invited', 'Pending', or Part of the Name",
  "INVITETOGROUP": "Invite",
  "GROUP_CAPACITY_EXCEEDED": "Group Capacity Exceeded",
  "NOPROMOTIONDEFINED": "No target group defined!",
  "DEST_MEMBERS": "Since destination contains members, this action cannot be undone. Click confirm to continue.",
  "NODEMOTIONDEFINED": "No Demotion Defined",
  "PROMOTION": "Promote",
  "DEMOTION": "Demote",
  "PROMOTED": "Members successfully promoted",
  "DEMOTED": "Members successfully demoted",
  "TRANSFER": "Transfered",
  "CONFIRM?": "Click confirm to continue.",
  "MEMBERS_SM": "member(s)",
  "FROM": "from",
  "TO": "to",
  "CONFIRMPROMOT": "This action will move all members from '@group1' to '@group2'. Any pending invitations and/or requests will be lost. Click confirm if you would like to proceed.",
  "CONFIRMDEMOT": "This action will move all members from this group to the demotion group. Any pending invitations and/or requests will be lost. Click confirm if you would like to proceed.",
  "SELECT_LEADERS": "Select Leader(s)",
  "SHOWGROUP_DEPARTMENTS": "Leaders",
  "SHOWGROUP_SUPERGROUPS": "Leaders",
  "CURRENT_LEADERS": "Current Leaders",
  "ALLOW_GROUP_CHAT": "Allow Group Chat",
  "ALLOW_PERSONAL_CHAT": "Allow Personal Chat",
  "THISEVENTONLY": "This Event Only",
  "ALLFUTUREEVENTS": "All Future Events",
  "THIS_OR_ALL_EVENTS": "Apply to this event only, or this event and all events following @Date?",
  "0REGISTRATION_UPDATE_SUCCESSFUL": "Registration Successfully Cancelled!",
  "APPLY_FILTER": "Apply Group Scope",
  "GROUP_REQUESTS": "Join requests",
  "MY_GROUPS": "My Groups",
  "SHOW_FLAGGED": "Show Flagged Names",
  "ROSTER_CHECKIN": "Roster",
  "REGISTERED_ONLY": "Registered Only",
  "START_TYPING": "Start Typing...",
  "EDIT": "Edit",
  "SELF": "Send To Self",
  "URL_LINK": "Url Link",
  "DIRECTORY": "People directory",
  "PARENTS": "Show Parents",
  "HAS_ROLE": "Has Role",
  "CURRENT_GROUPS": "Current Groups",
  "MULTI_DEMOTION_TARGETS": "Error: Multi Demotion Targets",
  "MULTI_PROMOTION_TARGETS": "Error: Multi Promotion Targets",
  "VISITS": "Visits",
  "CALLS": "Calls",
  "TASKS": "Outreach",
  "NOTES": "Notes",
  "WITH_NOTES": "With Notes",
  "WITHOUT_NOTES": "Without Notes",
  "SHOW_ALL": "Show All",
  "ADD_NOTE": "Add Note",
  "NOTE": "Note",
  "EDIT_NOTE": "Edit Note",
  "AUTHOR": "Author",
  "VIEW_NOTES": "View Notes",
  "DELETE_NOTE": "Delete this note?",
  "EXTRA": "View Notes",
  "FOLLOW_UP": "Follow Up",
  "BIRTHDAY": "Birthday",
  "EXPORT_TO_CALENDAR": "Export To Calendar",
  "DISABLE_TEXT": "Disable text communication",
  "ACCOUNT_HOLDER_EDIT": "Note: this is an account holder - only s/he can change their personal information.",
  "FORMS": "Forms",
  "ADDFORM": "Add Form",
  "REQUIRE_LOGIN": "Requires Login",
  "GUESTS": "Guests",
  "SCOPE": "Scope",
  "TO_ACTION": "To Action",
  "ADD_TO_GROUP": "Add to Group",
  "REGISTER_TO_EVENT": "Register to Event",
  "NEXT_FORM": "Sub Form",
  "INHERIT_MEMBER_INFO": "Inherit Member Information",
  "DISPLAY_IN_MENU": "Display In Menu",
  "RECIPIENTS": "Recipients",
  "ADD_BASIC_INFO": "Add Basic Information",
  "NEXT_FORM_TO_AUTHOR": "Append Subform to Author",
  "NEXT_FORM_TO_REVIEWER": "Append Subform to recipient",
  "APPROVERS": "Approvers",
  "REQUIRES_APPROVE": "Requires Approval",
  "EVENT_ID": "Event Id",
  "VALID_THRU": "Valid Thru",
  "FORM_EXPIRES": "Form Expires",
  "LIMIT_CAPACITY": "Limited Capacity",
  "ALLOW_DATA_EDIT": "Allow Data Edit",
  "FORM_SUBMISSION_MODE": "Form Submission Mode",
  "MULTIPLE": "Multiple",
  "FORM_BUILD": "Manage forms",
  "DESIGNATED_MEMBER": "Member",
  "FORM_SUBMISSIONS": "Form submissions",
  "MYPROFILE": "My Profile",
  "GROUP_SETUP": "Manage groups",
  "MY_FORMS": "My Forms",
  "DONATE": "Give to Church",
  "SYSTEM_SETTINGS": "System Settings",
  "REPORTS": "Reports",
  "SERVICE_SETUP": "Manage services",
  "REGISTRATIONS": "Registrations",
  "CHURCH_WEBSITE": "Church Website",
  "DISPLAY_MEMBERS": "View Members",
  "COMMUNICATION_LEVEL": "Communication Level",
  "EMAIL_ONLY": "Email Only",
  "EMAIL_PHONE": "Email & Phone",
  "PREFERED_LANGUAGE": "Preferred Language",
  "OPEN_GROUP": "Open Group",
  "DISABLE_EMAIL": "Disable Email Communication",
  "GROUP_LEADERS": "Group Leaders",
  "INVITATIONS": "Invitations",
  "YOUR_INVITED_TO_JOIN": "You are invited to join",
  "ACCEPT": "Accept",
  "REJECT": "Reject",
  "LEAVE": "Leave",
  "LEAVE_GROUP?": "leave group?",
  "JOIN_NEW_GROUP?": "Join a new group?",
  "JOIN": "Join",
  "REQUESTED": "Requested",
  "JOIN?": "Join ?",
  "PLEASE_ANSWER": "please answer the following question:",
  "CANCEL": "CANCEL",
  "CANNOT_FIND_SERVICE?": "Cannot see your service?",
  "SEND_TEXT": "Send Text",
  "SEND_EMAIL": "Send Email",
  "CONTENT": "Content",
  "EMAIL_SUBJECT": "Email Subject",
  "EMAIL_BODY": "Email Body",
  "SEND_TEXT_EMAIL": "Send Text and Email",
  "EVENTNOTTODAY": "This service is not available today",
  "FOLLOWUP": "Follow up",
  "SHOW_ON_MAP": "Show on map",
  "ASSIGN_TASK": "Assign outreach tasks",
  "MEMBER_COUNT": "Count of Selected Members",
  "VISIT": "Visit",
  "CALL": "Phone",
  "TASK": "Outreach task",
  "PLANNED": "Planned",
  "COMPLETE": "Completed",
  "DENIED": "Denied",
  "STATUS": "Status",
  "ASSIGNEE": "Assignee",
  "COUNT": "Count",
  "MY_TASKS": "My outreach tasks",
  "MANAGE_TASKS": "Manage outreach",
  "NOT_PLANNED": "No Plan",
  "NOT_COMPLETED": "No Completion",
  "ATTENDED": "Attendance",
  "OUT_REACH": "Outreach",
  "MANAGE_OUT_REACH": "Outreach Management",
  "MY_OUT_REACH_TASKS": "My Tasks",
  "MORE_THAN": "More than",
  "LESS_THAN": "Less than",
  "ATTENDANCE_FREQUENCY": "Frequency",
  "ANY_OF_ABOVE": "Any of the above",
  "FOLLOWUP_ACTIVITIES": "Outreach activities",
  "KEEP": "Keep",
  "DELETE_PLANS": "Delete Plans",
  "YES_DELETE": "Confirm Delete",
  "DONT_DELETE": "Don't Delete",
  "CLUSTER_MAP": "Cluster Map",
  "REFRESH_PAGE": "Refresh Page",
  "SCAN_TO_CHECKIN": "Scan me to Check-In",
  "UPDATE_FILTER": "Save Filter",
  "GROUPUPDATE": "Group Successfully Updated!",
  "GROUPFILTERUPDATE": "Group Filter Successfully Updated!",
  "HOUSEHOLD": "Household",
  "TIME": "Time",
  "GOTO_CHURCHSERVICES": "Church Services",
  "DATA_IMPORT": "Data Import",
  "UPLOAD_FILE": "Upload File",
  "DATA_MIGRATION": "Data Migration",
  "DISPLAY_COMMUNICATE": "Display and Communicate",
  "MATCH": "Match",
  "UNMATCH": "Unmatch",
  "VIEW_MODE": "View Mode",
  "ERROR": "Error",
  "NOTIFICATIONS": "Notifications",
  "HOUSEHOLD_SINGLE": "Household Single",
  "ACTIVITY_CHART": "Activity trends",
  "MAP_DISTRIBUTION": "People map",
  "SELECTIVE_COMMUNICATION": "Selective Communication",
  "DATA_DOWNLOAD": "Data Download",
  "DATA_EXPORT": "Data Export",
  "GROUP_COMMUNICATION": "Group Communication",
  "DEMOGRAPHICS": "Demographics",
  "AGE": "Age",
  "GRADE": "Grade",
  "AGE_GROUP": "Age Group",
  "EDUCATIONAL_STAGE": "Educational Stage",
  "AGE_RANGE": "Age Range",
  "SCHOOL_GRADE": "School Grade",
  "ACTIVITY_COUNT": "Activity Count",
  "OPT_IN_TEXT_EMAIL": "I also agree to receive text and email notifications at the phone number provided",
  "IS_PRIMARY_CHURCH?": "Is this your primary church?",
  "MEMBER_REQUIRED": "Status Required",
  "ADDRESS_VERIFICATION_REQUIRED": "Please verify address by clicking verify",
  "SUBSCRIPTION_INFORMATION": "Subscription Information",
  "GUEST_MAINTENANCE": "Guest Maintenance",
  "SUBSCRIPTION": "Subscription",
  "DELETE_GUESTS": "Delete Guests",
  "SUPER_ADMIN": "Super Admin",
  "CHURCHES": "Churches",
  "SHOWDISABLED": "Show Disabled",
  "SUBDOMAIN": "Subdomain",
  "ADDCHURCH": "Add New Church",
  "CHURCH_SETUP": "Church Setup",
  "PROVIDER_SECTION": "Provider Section",
  "CLIENT_SECTION": "Client Section",
  "TECHNICAL_SECTION": "Technical Section",
  "TIMEZONEDIFFERENCEREQUIRED": "Time Zone Difference Required",
  "TIMEZONE": "Time Zone (UTC Difference)",
  "SUBSCRIPTION_REQUIRED": "Subscription Required, Min 250",
  "TEXTS_MONTH": "Texts / Month",
  "VONAGE_NUMBER_REQUIRED": "Vonage Number Required",
  "VONAGE_NUMBER": "Vonage Number",
  "IS_DIOCESE": "Is this a diocese?",
  "IS_DENOMINATION": "Is this a denomination?",
  "DIOCESE_DOMAIN": "Diocese Domain",
  "DENOMINATION_DOMAIN": "Denomination Domain",
  "TERMINATED": "Check to terminate service",
  "CHURCH_SHORT_NAME": "Short Name - Next to Logo",
  "CHURCH_OFFICIAL_NAME": "Official Church Name",
  "MASS_EMAILER_NAME": "Mass Emailer Name",
  "CHURCH_CONTACT_PERSON": "Church Contact Person",
  "CHURCH_EMAIL": "Church Email Address",
  "CHURCH_PHONE": "Church Phone Number",
  "DONATION_LINK": "Donation Link",
  "CHURCH_STREET_ADDRESS": "Church Street Address",
  "DEFAULT_LANGUAGE": "Default Language",
  "MEMBERSHIP_WORKFLOW": "Membership Workflow",
  "ALLOW_TEXTING": "Allow Texting",
  "CONNECTIONSTRING": "Connection String to Database",
  "FIELD_REQUIRED": "Field Required",
  "SENDGRIDAPI": "SendGrid API Key",
  "ACTIVATION_TEMPLATE": "Activation Template",
  "RESET_TEMPLATE": "Reset Template",
  "VONAGE_KEY": "Vonage Key",
  "VONAGE_SECRET": "Vonage Secret",
  "CANCELLATION_TEMPLATE": "Cancellation Template",
  "CONFIRMATION_TEMPLATE": "Confirmation Template",
  "MESSAGE_TEMPLATE": "Message Template",
  "AGREEMENT_URL": "Agreement Url",
  "CHECK_NEW_SECRETS": "Load New Secrets from Secret Store",
  "CHURCH_LOGO": "Church Logo",
  "USER_GROUPS": "User Groups",
  "FROM_1_200": "Value should be between 1 and 200",
  "AUTOUPDATE": "Auto Update",
  "MOVE_ONE_UP": "One Grade Up",
  "MOVE_TWO_UP": "Two Grades Up",
  "MOVE_THREE_UP": "Three Grades Up",
  "MOVE_ONE_DOWN": "One Grade Down",
  "MOVE_TWO_DOWN": "Two Grades Down",
  "MOVE_THREE_DOWN": "Three Grades Down",
  "TAKING_LONG_HOME": "Taking too long?",
  "CLICK_HERE": "Click here",
  "WAITED_LONG?": "Waited long?",
  "CHURCH": "Church",
  "INVALID_DATA": "Invalid Data",
  "INVALID_FIRSTNAME": "Invalid First Name",
  "INVALID_LASTNAME": "Invalid Last Name",
  "INVALID_EMAIL": "Invalid Email Address",
  "INVALID_STREET": "Invalid Street",
  "INVALID_CITY": "Invalid City",
  "INVALID_COUNTRY": "Invalid Country",
  "INVALID_MARITALSTATUS": "Unknown Marital Status",
  "INVALID_DOB": "Invalid Date of Birth",
  "INVALID_DIALCODE": "Invalid Dial Code",
  "INVALID_LANGUAGE": "Unknown Language",
  "INVALID_PHONENUMBER": "Invalid Phone Number (remove symbols)",
  "INVALID_STATE": "Invalid State",
  "INVALID_ZIP": "Invalid Zip Code",
  "INVALID_ACCOUNT": "Invalid Account",
  "INVALID_ATTENDANCE_INFO": "Invalid Attendance Information",
  "INVALID_BIRTHDAY": "Invalid Birthday Information",
  "INVALID_DEPARTMENT": "Invalid Department Selection",
  "INVALID_SUPERGROUP": "Invalid Super Group Selection",
  "INVALID_GROUP": "Invalid Group Selection",
  "INVALID_DIOCESE": "Invalid Diocese Selection",
  "INVALID_OUTREACH_INFO": "Invalid Outreach Information",
  "INVALID_ROLE": "Invalid Role Selection",
  "INVALID_NOTE_SELECTION": "Invalid Note Selection",
  "INVALID_OUTREACH_ASSIGNEE": "Invalid Outreach Assignee",
  "INVALID_ATTENDANCE_PERIOD": "Invalid Outreach Period",
  "INVALID_RESULT_SCOPE": "Invalid Result Type Selection",
  "SELECTIVE": "By Selection",
  "COLLECTIVE": "By Group",
  "PHONE_UNVERIFIED": "Phone Number Unverified",
  "ENTER_4DIGIT": "Enter 4 digit then Click Verify",
  "CLICK_TO_CHANGE": "Click to Change",
  "PHONEACCOUNTACTIVATED": "Congratulations, your account has been successfully created. Please login",
  "REACTIVATE_NOTIFICATION": "You are receiving this email because you have recently changed your account's email for @CHURCHNAME's System. Please proceed to activate your account by clicking the below Activate Account button. Thank you!",
  "PHONE_OR_EMAIL": "Email or Cell Phone",
  "NOT_AUTHORIZED": "You are not authorized to complete this action",
  "VERIFYPHONE_TO_SAVE": "You must verify your phone number to save",
  "RECURENCE": "Recurence",
  "GIVING_HISTORY": "Giving History",
  "DEDUCTIBLE": "Deductible",
  "NONDEDUCTIBLE": "Non Deductible",
  "PAYMENTS": "Payments",
  "PAYMENT_HISTORY": "Payment History",
  "GIVING_REPORT": "Giving Report",
  "FUND_TYPES": "Fund Types",
  "HOUSEHOLD_CODE": "Household Code",
  "ADDRESS": "Address",
  "CREATE_RECORDS": "Create Selected Records",
  "DOCUMENTS": "Documents",
  "BY_MONTH": "By Month",
  "BY_DAY": "By Day",
  "DOCUMENT_CENTER": "Document Center",
  "MY_GIVINGS": "My Givings",
  "RESTRICT_TO_MEMBER": "Restrict Access to Member",
  "NO_SUBMIT_BUTTON": "Hide Submit Button",
  "UPDATE_GROUP": "Save Group",
  "VERIFY_PHONE_ERROR": "Verify Phone: Enter 4 Digit Code and Click Verify",
  "UPDATE_PHONE": "Update Phone Number",
  "REFRESH_ALL_GROUPS": "Refresh All Groups",
  "EVERY_OTHER_WEEK": "Every other week",
  "ATTENDANCE_CHART": "Chart",
  "DATE_RANGE": "Date Range",
  "DONE": "Done",
  "OPEN": "Open",
  "ASSIGN": "Assign",
  "BLOCK": "Block",
  "BLOCK_MESSAGE": "Would you like to block this slot only or block all day?",
  "SLOT": "Slot",
  "BLOCKALLDAY": "All Day",
  "UNBLOCK": "Unblock",
  "UNBLOCK_MESSAGE": "Would you like to unblock this slot only or unblock all day?",
  "REGISTER": "Register",
  "IN": "IN",
  "OUT": "OUT",
  "CHECKED_IN": "Checked",
  "ALL_SERVICES": "All Services",
  "ALL_LOCATIONS": "All Locations",
  "PROCESS_COMMUNICATE": "Process & Communicate",
  "QUESTION": "Question Text",
  "ANSWERS": "Delimited Answers",
  "VOLUNTEERING": "Volunteering",
  "SETUP": "Setup",
  "MYACTIVITIES": "My Activities",
  "EXCEL_SHEET": "Excel",
  "VIEW_REPORT": "View Report",
  "REQUEST_SIGNUP_TEXT": "Request to Signup by Text",
  "VOLUNTEERING_TABLES": "Volunteering Setup Sheets",
  "ADD_VOLUNTEER_TABLE": "Add New Setup Sheet",
  "HIDE_LEADERS": "Hide Leaders",
  "ADD_NEW_ROLE": "Add New Role",
  "VOLUNTEERING_DETAILS": "Volunteering Details",
  "ROLE": "Role",
  "ALLOW_SELF_ASSIGN": "Allow to self assign",
  "CONFIRM_DELETE": "Are you sure you want to delete this record? Click again to delete.",
  "MIN_COUNT": "Min Count",
  "MAX_COUNT": "Max Count",
  "BARCODE_GENERATOR": "Code Generator",
  "GENERATE": "Generate",
  "FACE_SCANNER": "Have QR code face scanner to Check-In",
  "ADD_ID_TO_HOMESCREEN": "Add this page to home screen for future use.",
  "CHECKIN_BARCODE": "Display ID",
  "DONATION_DETAIL": "Donation Details",
  "CASH": "Cash",
  "CHECK": "Check",
  "ONLINE": "Online",
  "DONATION_TYPE": "Donation Type",
  "FUND_TYPE": "Fund Type",
  "CHARGE_DATE": "Charge Date",
  "AMOUNT": "Amount",
  "ADD_DONATION": "Add Donation",
  "SAVE_DONATION": "Save Donation",
  "SHOW_DELETED": "Show Deleted",
  "BACK": "Back",
  "RESTORE": "Restore",
  "POSSIBLE_ACCOUNTS": "Possible Accounts",
  "SELECT_ACCOUNTS_TO_LINK": "Select Accounts To Link",
  "LINK_ACCOUNTS": "Link Selected Accounts",
  "APP_NAME": "App Name",
  "DONATION_LEVEL": "Report Level",
  "SINGLE_DONATION": "Single Donation",
  "TOTAL_DONATION": "Total Donations",
  "DONATION_START_RANGE": "Amount From",
  "DONATION_END_RANGE": "To",
  "INCLUDE_EXTERNAL": "Include External Accounts",
  "GIVING": "Giving",
  "INTERNAL": "Internal",
  "EXTERNAL": "External",
  "ACCOUNTS": "Accounts",
  "SENDDATE": "Scheduled Date",
  "SENDTIME": "Send Time",
  "SCHEDULESEND": "Schedule for later",
  "TAX_ID": "Tax ID",
  "HOUSEHOLD_MEMBER_SELECTION": "Household Members Selection",
  "SUBMIT_AND_PAY": "Submit & Pay",
  "SUBMIT_URL": "Submit URL",
  "DAYS_TO_NOTIFY": "Days to Notify",
  "DETAILED_DAYS_TO_NOTIFY": "Notify before the event date by how many days",
  "NOTIFICATION_HOUR": "Notification Hour",
  "DAYS_TO_REMIND": "Days to Remind",
  "DETAILED_DAYS_TO_REMIND": "Send Reminder before the event date by how many days",
  "REMINDER_HOUR": "Reminder Hour",
  "SERVICE_DEPENDENCY_ERROR": "Error deleting record. This record might be used by active services.",
  "SERVICE_LEADERS": "Service Leaders",
  "VOLUNTEER_SHEET": "Volunteer Sheet",
  "VOLUNTEERING_SETUP": "Volunteering Setup",
  "SELF_ASSIGN": "Self Assign",
  "AUTO_ASSIGN": "Auto Assign",
  "AUTO_MODE_WITH_NOTE": "Automatic Selection (Select location to enable)",
  "CONTENT_MANAGEMENT": "Content Management",
  "CONFIGURE": "Configure",
  "ADDNEWCOMPONENT": "Add New Component",
  "COMPONENT": "Component",
  "TITLE": "Title",
  "TRANSLATION": "Translation",
  "COMPONENT_SIZE": "Component Size",
  "SMALL": "Small",
  "LARGE": "Large",
  "TITLEPOSITION": "Title Position",
  "TOP": "Top",
  "CENTER": "Center",
  "BOTTOM": "Bottom",
  "CONTENTTYPE": "Content Type",
  "LINK": "Direct Link",
  "TEXT_BUTTONS": "Text & Buttons",
  "LINKS": "List of Links",
  "FOLDERS": "Folders",
  "COMPONENT_PRIORITY": "Component Priority",
  "TRANSLATED_TITLE": "Translated Title",
  "SAVE_COMPONENT": "Save Component",
  "IMAGE": "Image",
  "CONFIGURATION_SCREEN": "Configuration Screen",
  "ACTIVE": "Active",
  "SHOW_INACTIVE": "Show Inactive",
  "DIRECTIONS": "Get directions",
  "TITLE_COLOR": "Title Color",
  "LIGHT": "Light",
  "DARK": "Dark",
  "SHOW_IMAGE_IN_CONTENT": "Show Image in Content",
  "OPEN_CONTENT": "Content Details",
  "TEST_LINK": "Test Link",
  "SAVE_DETAILS": "Save Details",
  "COPY": "Copy",
  "OUR_LOCATION": "Our Location",
  "TEXT_AND_BUTTONS": "Text & Buttons",
  "BUTTON1_NAME": "1st Button Name",
  "BUTTON12_NAME": "Translation",
  "BUTTON1_URL": "1st Button URL",
  "BUTTON2_NAME": "2nd Button Name",
  "BUTTON22_NAME": "Translation",
  "BUTTON2_URL": "2nd Button URL",
  "BUTTON3_NAME": "3rd Button Name",
  "BUTTON32_NAME": "Translation",
  "BUTTON3_URL": "3rd Button URL",
  "FOLDER_NAME": "Folder Name",
  "LINK_NAME": "Link Name",
  "ADD_FOLDER": "Add New Folder",
  "ADD_LINK": "Add New Link",
  "LINK_NAME2": "Translated Link Name",
  "SYMBOL": "Sybmol",
  "DELETE_LINK": "Are you sure you want to delete this link?",
  "BY_DATE_ASC": "Ascending Date",
  "BY_DATE_DESC": "Descending Date",
  "ALPHABETICAL": "Alphabetical",
  "CONTENT_ORDER": "Content Order",
  "FOLDER_NAME2": "Translated Folder Name",
  "SAVE_FOLDER": "Save Folder",
  "DELETE_FOLDER": "Are you sure you want to delete this folder?",
  "NO_LINKS_FOUND": "No Links Found! ",
  "NO_FOLDERS_FOUND": "No Folders Found!",
  "SYSTEM_MENU": "System Menu",
  "CONTENT_LIST": "List of Contents",
  "NO_CONTENTS": "No contents found!",
  "ADD_NEW_CONTENT": "Add New Content",
  "CONTENT_NAME": "Content Name",
  "CONTENT_NAME2": "Translated Content Name",
  "SAVE_CONTENT": "Save Content",
  "SAVE_OPEN": "Save & Open",
  "HOME": "Home",
  "CONSENT": "By clicking YES, you are accepting the data privacy policy and committing to not sharing any accessed information with unauthorized parties.",
  "PRAYER_REQUEST": "Prayer Request",
  "FAST_CHECKIN": "Fast Checkin",
  "TAX_STATEMENT": "Tax Statement",
  "ROSTER_MODE": "Roster",
  "ALL_LANGUAGES": "All Languages",
  "ENGLISH_ONLY": "English Only",
  "ARABIC_ONLY": "Arabic Only",
  "SHOW_CONTENT": "Show Content",
  "CONTENT2": "Translated Content",
  "SELF_CHECKIN": "Self Check-In",
  "OUTREACH_CHART": "Outreach Chart",
  "ALLOW_RSVP": "Allow RSVP",
  "CONNECTION_ERROR": "Connection Error!",
  "OCCUPATION": "Occupation",
  "ACCOUNT_EXISTS": "Account Already Exists",
  "OCCUPATION_REQUIRED": "Occupation Required",
  "EMAIL_EXISTS_FOR_A_DIFFERENT_MEMBER": "Error Saving: this email address exists for a different member!",
  "PHONE_EXISTS_FOR_A_DIFFERENT_MEMBER": "Error Saving: this phone number exists for a different member!",
  "MEMBER_PREVIOUSLY_DEFINED_WITH_DIFFERENT_DOB": "Error Saving: Member previously defined with a different date of birth, please enter the same date of birth or update it in the other source",
  "RECENCY_SORT": "By Recency",
  "POINT_SYSTEM": "Point systems",
  "ACTIVITY": "Activity",
  "ADD_POINT": "Add Points",
  "DEDUCT_POINT": "Deduct Points",
  "SHOW_DETAILS": "Show Details",
  "HIDE_DETAILS": "Hide Details",
  "BARCODE": "Barcode",
  "ADD_SYSTEM": "Add New System",
  "POINT_ASSIGNMENT": "Who gives points",
  "SERVANT": "Servant",
  "BOTH": "Both",
  "UPDATE_SYSTEM": "Update System",
  "HIDE_SYSTEM": "Hide System",
  "SYSTEMUPDATE": "Point System Successfully Saved!",
  "DELETE_ACTIVITY": "Deleting this activity will remove it and it's corresponding points from all people who earned it. Are you sure you want to delete?",
  "UPDATE_ACTIVITY": "Updating this activity name or points will be applied to all people who earned it. Are you sure you want to update?",
  "ACTIVITY_NAME_REQUIRED": "Please enter a valid name",
  "ACTIVITY_POINTS_REQUIRED": "Please enter a numberic value for points",
  "ACTIVITY_LIST": "Activity List",
  "ACTIVITY_NAME": "Activity Name",
  "STARS": "Points",
  "EDIT_POINTS": "Edit Points",
  "LEAVE_GROUP": "Leave Group",
  "ACCOUNT_INACTIVE_TYPE": "Inactive Account",
  "RESEND_ACTIVATION_EMAIL": "Resend Activation Email",
  "ACTIVATION_EMAIL_SENT": "Activation email successfully sent!",
  "DEPARTED": "Departed",
  "ACCOUNT_MAINTENANCE": "Account Maintenance",
  "DELETE_ACCOUNT": "Delete Account",
  "CONFIRM_DELETE_ACCOUNT": "This action will delete the selected account with its household and all their corresponding history of activities and related information. This cannot be undone. Are you sure you want to proceed?",
  "INCLUDE_MASS_TEXT": "Include Mass Texts",
  "CREATE_EVENTS": "Create Imported Events",
  "IS_PRIMARY_CHURCH": "Is this your primary church?",
  "INVALID_ADDRESS": "Invalid Address",
  "SELECTTENANT": "Choose My Church",
  "CHURCH_ID": "Enter Church Id",
  "CHURCH_ID_REQUIRED": "Church ID is Required",
  "OPEN_CHURCH": "Open Church",
  "CHANGE_CHURCH": "Change Church",
  "AGREE_CONTENT": "I acknowledge that I have reviewed and agree to abide to Church Services LLC terms of use with regard to posting good content, as described in section 10 (User Conduct)",
  "REVIEW_TERMS_HERE": "I agree to the terms of service",
  "UNSUBSCRIBE_ACCOUNT": "Unsubscribe Account",
  "CONFIRM_UNSUBSCRIBE": "By unsubscribing, your account and all your personal information will be permanently removed from the system. Are you sure you would like to unsubscribe?",
  "VOLUNTEER_ORDER": "Order Assignee By",
  "RANDOM": "Random",
  "SYSTEM": "System",
  "HAS_CMS_MODULE": "Has CMS Module",
  "EVENT_NOT_AVAILABLE": "Event is not available today!",
  "CHECKIN_FAILURE": "Check-in Failure",
  "PUSH_NOTIFICATION": "Push Notifications",
  "ENABLED": "Enabled",
  "DISABLED": "Disabled",
  "OPTIN_TEXT": "By checking this box, I agree to receive text notifications related to Upcoming Events, Seasonal Greetings, Birthday Greetings, and Volunteer assignments from",
  "NOTIFICATIONS_SENT": "Notification(s) successfully scheduled!",
  "FORM_EXPIRED": "This form has expired!",
  "MESSAGE": "Message",
  "NOTICE": "Notice",
  "DELETE_NOTIFICATIONS": "Are you sure you would like to delete the selected notifications?",
  "NOTIFICATION_NOT_FOUND": "This notification was not found",
  "TAGS": "Tags",
  "ADDTAG": "Add New Tag",
  "COLOR": "Color",
  "RED": "Red",
  "GREEN": "Green",
  "BLUE": "Blue",
  "YELLOW": "Yellow",
  "ORANGE": "Orange",
  "BROWN": "Brown",
  "GRAY": "Gray",
  "WHITE": "White",
  "BLACK": "Black",
  "PURPLE": "Purple",
  "PAYMENT_ADAPTERS": "Payment Adapters",
  "MEDIA": "Media",
  "SHOW_DELETED_1F65DFF": "Show deleted",
  "DELETE_OR_RESTORE_RECORD": "Delete or restore record",
  "QR_CODE": "QR code",
  "COPIED": "Copied",
  "COPY_LINK": "Copy link",
  "SET_DEFAULT": "Set default",
  "OUTREACH_TASKS_SUCCESSFULLY_SUBMITTED": "Outreach tasks successfully submitted!",
  "FIRST_PAGE": "First page",
  "PREVIOUS_PAGE": "Previous page",
  "NEXT_PAGE": "Next page",
  "LAST_PAGE": "Last page",
  "SORT": "Sort",
  "FIRST": "First",
  "LAST": "Last",
  "RETAIN_SELECTION": "Retain Selection",
  "ACCOUNT_VERIFICATION_METHOD": "Account verification method",
  "PHONE_SMS": "Phone (SMS)",
  "SMS_REQUIRES_A_PHONE_CODE_EMAIL_REQUIRES_A_VERIFIED_EMAIL_ADDRESS_BEFORE": "SMS requires a phone code. Email requires a verified email address before account activation. Devices are remembered automatically for quick check-in.",
  "PNG_512X512_2MB_OR_LESS": "PNG 512x512 (2MB or less)",
  "INVALID_FILE": "Invalid File!",
  "CHURCH_SERVICES_ORG": ".church-services.org",
  "CALCULATOR": "Calculator",
  "CHURCH_DOMAIN_IS_ALREADY_USED": "Church Domain is Already Used!!",
  "CHURCH_SUCCESSFULLY_SAVED": "Church Successfully Saved!!",
  "DUPLICATE": "Duplicate",
  "ALL_DAY": "All day",
  "MOVE_UP": "Move Up",
  "MOVE_DOWN": "Move Down",
  "DELETE_COMPONENT": "Delete component",
  "THIS_COMPONENT_WILL_APPEAR_ON_THE_HOME_PAGE_AGAIN": "This component will appear on the home page again.",
  "THIS_COMPONENT_WILL_BE_HIDDEN_FROM_THE_HOME_PAGE_YOU_CAN_RESTORE_IT_USIN": "This component will be hidden from the home page. You can restore it using Show Inactive.",
  "OPEN_RICH_EDITORS": "Open Rich Editors",
  "MEDIA_TYPE": "Media Type",
  "VIDEO": "Video",
  "AUDIO": "Audio",
  "SOURCE": "Source",
  "UPLOAD": "Upload",
  "YOUTUBE": "YouTube",
  "URL": "URL",
  "MEDIA_NAME": "Media Name",
  "UPLOAD_MEDIA": "Upload Media",
  "YOUTUBE_URL": "YouTube URL",
  "MEDIA_URL": "Media URL",
  "VIDEO_THUMBNAIL": "Video Thumbnail",
  "CURRENT_MEDIA": "Current Media",
  "YOUTUBE_VIDEO_SELECTED": "YouTube video selected",
  "CHANGES_SUCCESSFULLY_SAVED": "Changes Successfully Saved!",
  "YOUR_BROWSER_DOES_NOT_SUPPORT_VIDEO_PLAYBACK": "Your browser does not support video playback.",
  "YOUTUBE_VIDEO": "YouTube video",
  "YOUR_BROWSER_DOES_NOT_SUPPORT_AUDIO_PLAYBACK": "Your browser does not support audio playback.",
  "SHARE": "Share",
  "THIS_NOTIFICATION_IS_UNAVAILABLE": "This notification is unavailable",
  "RETURN_TO_NOTIFICATIONS_TO_VIEW_AVAILABLE_UPDATES": "Return to notifications to view available updates.",
  "TOTAL_AB2882C": "TOTAL",
  "AGE_RANGE_COUNT": "Age Range Count",
  "SCHOOL_GRADE_COUNT": "School Grade Count",
  "CITY_COUNT": "City Count",
  "STATE_COUNT": "State Count",
  "LEGEND": "LEGEND",
  "VALUE": "VALUE",
  "YYYY_MM_DD": "yyyy-MM-dd",
  "ACCEPT_PAYMENTS": "Accept Payments",
  "PAYMENT_ACCOUNT": "Payment Account",
  "SELECT_AN_EXISTING_FUND_TYPE_OR_ENTER_A_NEW_ONE": "Select an existing Fund Type or enter a new one.",
  "PAYMENT_DESCRIPTION": "Payment Description",
  "CURRENCY": "Currency",
  "REQUIRE_SUCCESSFUL_PAYMENT": "Require Successful Payment",
  "SEND_PAYMENT_RECEIPT": "Send Payment Receipt",
  "OPEN_RICH_EMAIL_EDITOR": "Open Rich Email Editor",
  "FORM_URL": "Form URL",
  "TEST_FORM": "Test Form",
  "FORM_PICTURE": "Form Picture",
  "FORM_PICTURE_DF7D3D5": "Form picture",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TASK": "Are you sure you want to delete this task?",
  "TASK_HAS_BEEN_SUCCESSFULLY_UPDATED": "Task has been successfully updated!",
  "TOTAL_ACTIVITY": "Total Activity",
  "FUND_NAME": "Fund Name",
  "IS_TAX_DEDUCTIBLE": "Is Tax Deductible",
  "QUESTION_289AFF1": "Question",
  "ANSWER": "Answer",
  "GROUP_SETTINGS": "Group settings",
  "STATUS_DELETED": "Status: Deleted",
  "BASIC_INFORMATION": "Basic information",
  "GROUP_PHOTO": "Group photo",
  "ACCESS_JOINING": "Access & joining",
  "VISIBILITY_COMMUNICATION": "Visibility & communication",
  "MEMBERSHIP_PROGRESSION": "Membership & progression",
  "MEMBERSHIP_MANAGEMENT": "Membership management",
  "MANUAL_MANAGE_MEMBERS_YOURSELF": "Manual — manage members yourself",
  "AUTOMATIC_USE_THE_SAVED_FILTER": "Automatic — use the saved filter",
  "AUTOMATIC_UPDATES_ADD_PEOPLE_WHO_MATCH_THE_SAVED_FILTER_AND_REMOVE_PEOPL": "Automatic updates add people who match the saved filter and remove people who no longer match. Save your membership filter below.",
  "ADD_OR_REMOVE_MEMBERS_USING_THE_LIST_BELOW_YOU_CAN_SAVE_A_FILTER_NOW_AND": "Add or remove members using the list below. You can save a filter now and enable automatic updates later.",
  "SAVE_GROUP_SETTINGS": "Save group settings",
  "MEMBERSHIP_FILTER_PEOPLE": "Membership filter & people",
  "FIND_PEOPLE_DEFINE_THE_FILTER": "Find people & define the filter",
  "CHOOSE_SEARCH_CRITERIA_THEN_SEARCH_TO_REVIEW_MATCHING_PEOPLE_USE_MORE_FO": "Choose search criteria, then search to review matching people. Use More for additional criteria. Saving the filter stores these criteria, not the people you select.",
  "SAVE_MEMBERSHIP_FILTER": "Save membership filter",
  "SAVES_THE_CURRENT_SEARCH_CRITERIA_FOR_THIS_GROUP_S_AUTOMATIC_MEMBERSHIP_": "Saves the current search criteria for this group's automatic membership updates.",
  "PEOPLE_MEMBER_ACTIONS": "People & member actions",
  "SHOW_FLAGS": "Show Flags",
  "SHOW_LEADERS": "Show Leaders",
  "LEADER": "Leader",
  "PROCESS_WILL_RUN_ON_THE_BACKGROUND_AN_EMAIL_WILL_BE_SENT_UPON_COMPLETION": "Process will run on the background. An email will be sent upon completion!",
  "RECORDS_SUCCESSFULLY_DELETED": "Records Successfully Deleted!",
  "DATA_PRIVACY": "Data Privacy",
  "IT_IS_HIGHLY_RECOMMEND_THAT_CHURCH_MEMBERS_SELF_SIGNUP_AND_AGREE_TO_SHAR": "It is highly recommend that Church members self-signup and agree to share their personal information with the church.",
  "SIGNUP_S": "Signup's",
  "LEGACY": "Legacy",
  "MATCHES": "Matches",
  "UPLOAD_DATA": "Upload Data",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALL_TEMPORARY_IMPORTED_DATA": "Are you sure you want to delete all temporary/imported data?",
  "DATA_SUCCESSFULLY_DELETED": "Data successfully deleted!",
  "DELETE_ALL_LEGACY": "Delete All Legacy",
  "ARE_YOU_SURE_YOU_WANT_TO_GENERATE_ALL_POSSIBLE_ACCOUNTS_AND_RELATIONS": "Are you sure you want to generate all possible accounts and relations?",
  "THE_BUILD_STARTED_AND_WILL_TAKE_FEW_MINUTES_AN_EMAIL_WILL_BE_SENT_UPON_C": "The build started and will take few minutes. An email will be sent upon completion.",
  "BUILD_ALL_POSSIBLE": "Build All Possible",
  "DOWNLOAD_IMPORT_TEMPLATE": "Download Import Template",
  "FAST_URL_LINKS": "Fast URL Links",
  "CLICKING_ON_ANY_OF_THE_BELOW_BUTTONS_WILL_COPY_THE_LINK_TO_YOUR_CLIPBOAR": "Clicking on any of the below buttons will copy the link to your clipboard. Feel free to share with your church members as and when needed",
  "QUICK_SUBSCRIPTION_LINK": "Quick Subscription Link",
  "COPIED_5A11AE5": "- Copied!",
  "QUICK_PROFILE_UPDATE_LINK": "Quick Profile Update Link",
  "DOWNLOAD": "Download",
  "PAID": "Paid",
  "AWAITING_PAYMENT": "Awaiting Payment",
  "THIS_SUBMISSION_HAS_BEEN_SAVED_AND_IS_WAITING_FOR_PAYMENT": "This submission has been saved and is waiting for payment.",
  "CREATE_PAYMENT_LINK": "Create Payment Link",
  "PAYMENT_SUCCESSFULLY_RECEIVED": "Payment Successfully Received",
  "DELETE_THIS_FORM_SUBMISSION": "Delete this form submission?",
  "UPDATE_C1C1009": "Update",
  "BRAND_COLOR_THEME": "Brand color theme",
  "SELECTED_THEME_COLORS": "Selected theme colors",
  "PRIMARY_COLOR": "Primary color",
  "SUBMENU_COLOR": "Submenu color",
  "SELECTED_ITEM_COLOR": "Selected item color",
  "PAGE_BACKGROUND_COLOR": "Page background color",
  "CARD_AND_FORM_COLOR": "Card and form color",
  "CREATE_AND_CONFIRMATION_COLOR": "Create and confirmation color",
  "DELETE_AND_ERROR_COLOR": "Delete and error color",
  "WARNING_COLOR": "Warning color",
  "INFORMATION_COLOR": "Information color",
  "CREATE": "Create",
  "THEME_MESSAGE_EXAMPLES": "Theme message examples",
  "CONFIRMATION_CHANGES_SAVED": "Confirmation: changes saved.",
  "ERROR_CHANGES_COULD_NOT_BE_SAVED": "Error: changes could not be saved.",
  "WARNING_UNSAVED_CHANGES": "Warning: unsaved changes.",
  "INFO_REQUIRED_FIELDS_ARE_MARKED": "Info: required fields are marked.",
  "NOTE_SUCCESSFULLY_ADDED": "Note successfully added!!",
  "PROVIDER": "Provider",
  "PAYMENT_URL": "Payment URL",
  "PAYPAL_CONFIGURATION": "PayPal Configuration",
  "CLIENT_ID": "Client ID",
  "SECRET": "Secret",
  "SANDBOX": "Sandbox",
  "PUSHPAY_CONFIGURATION": "Pushpay Configuration",
  "GIVING_HANDLE": "Giving Handle",
  "E_G_STMARKDC": "e.g. stmarkdc",
  "HOSTED_PAYMENTS": "Hosted Payments",
  "PUSHPAY_HOSTED_PAYMENTS_DO_NOT_REQUIRE_AN_API_CONNECTION_CHURCH_SERVICES": "Pushpay hosted payments do not require an API connection.\n              Church Services can redirect donors directly to your Pushpay\n              giving page.",
  "OPTIONAL_API_CONNECTION": "Optional API Connection",
  "CONNECTED_TO_PUSHPAY": "Connected to Pushpay",
  "ORGANIZATION": "Organization",
  "MERCHANT": "Merchant:",
  "ENVIRONMENT": "Environment:",
  "API_CONNECTION_IS_OPTIONAL": "API connection is optional.",
  "HOSTED_PUSHPAY_PAYMENTS_WORK_WITHOUT_AN_API_CONNECTION_CONNECT_YOUR_PUSH": "Hosted Pushpay payments work without an API connection.\n                Connect your Pushpay account if you have API access and want\n                Church Services to verify payments directly with Pushpay.",
  "CONNECTING": "Connecting...",
  "SAVE_THE_PAYMENT_ADAPTER_BEFORE_CONNECTING_IT_TO_PUSHPAY": "Save the payment adapter before connecting it to Pushpay.",
  "ACCOUNT_CONNECTION": "Account Connection",
  "THIS_PAYMENT_ADAPTER_IS_NOT_YET_CONNECTED_TO_A": "This payment adapter is not yet connected to a",
  "ACCOUNT_CLICK": "account.\n\n            Click",
  "BELOW_TO_AUTHORIZE_CHURCH_SERVICES_TO_PROCESS_PAYMENTS_ON_BEHALF_OF_YOUR": "below to authorize Church Services to process\n            payments on behalf of your organization.",
  "ACCOUNT_ID": "Account ID",
  "ENVIRONMENT_9E47195": "Environment",
  "SAVE_THE_PAYMENT_ADAPTER_BEFORE_CONNECTING_IT": "Save the payment adapter before connecting it.",
  "TITHELY_CONFIGURATION": "Tithely Configuration",
  "API_KEY": "API Key",
  "CUSTOM_REDIRECT_PROVIDER": "Custom Redirect Provider",
  "AUTOMATIC_PAYMENT_VERIFICATION_IS_NOT_GUARANTEED_AND_DEPENDS_ON_THE_CAPA": "Automatic payment verification is not guaranteed and depends on the capabilities of the external provider.",
  "DEFAULT": "Default",
  "SAVE_PAYMENT_ADAPTER": "Save Payment Adapter",
  "SAVING": "Saving...",
  "ADD_PAYMENT_ADAPTER": "Add Payment Adapter",
  "REMOVE": "Remove",
  "MM_DD_YYYY": "MM/DD/YYYY",
  "SEARCH_TAGS": "Search tags",
  "A_KEYWORD_THAT_HELPS_YOU_FIND_THIS_SERVICE": "A Keyword that helps you find this service",
  "MINISTRY": "Ministry *",
  "SCHEDULE_CALENDAR": "Schedule & calendar",
  "MULTIPLE_APPOINTMENTS": "Multiple Appointments",
  "APPOINTMENT_DURATION": "Appointment duration",
  "UPCOMING_EVENTS_IN_CALENDAR": "Upcoming events in calendar",
  "NUMBER_OF_UPCOMING_OCCURRENCES_TO_KEEP_LIVE_IN_THE_CALENDAR_1_TO_200": "Number of upcoming occurrences to keep live in the calendar (1 to 200).",
  "CAPACITY_RESERVATIONS": "Capacity & reservations",
  "MAX_RESERVATIONS_PER_HOUSEHOLD": "Max reservations per household",
  "MAXIMUM_SPOTS_A_HOUSEHOLD_CAN_RESERVE_FOR_EACH_EVENT": "Maximum spots a household can reserve for each event.",
  "SPOTS_RESERVED_FOR_CHURCH_ASSIGNMENT": "Spots reserved for church assignment",
  "INCLUDED_IN_TOTAL_CAPACITY_BUT_UNAVAILABLE_FOR_PUBLIC_RESERVATIONS_THE_C": "Included in total capacity, but unavailable for public reservations. The church can assign these spots.",
  "RSVP_CLOSES_BEFORE_EVENT": "RSVP closes before event",
  "CHOOSE_HOW_LONG_BEFORE_THE_EVENT_STARTS_RESERVATIONS_CLOSE": "Choose how long before the event starts reservations close.",
  "ELIGIBILITY_ACCESS": "Eligibility & access",
  "EXCLUSIVE_ACCESS": "Exclusive Access",
  "AGE_RESTRICTION": "Age restriction",
  "GENDER_RESTRICTION": "Gender restriction",
  "REGISTRATION_QUESTION": "Registration question",
  "OPTIONAL_QUESTION_SHOWN_DURING_REGISTRATION": "Optional question shown during registration.",
  "ANSWER_OPTIONS": "Answer options",
  "ONE_OPTION_PER_LINE": "One option per line",
  "ENTER_ONE_OPTION_PER_LINE_COMMAS_ALSO_SEPARATE_OPTIONS_THESE_CHOICES_APP": "Enter one option per line. Commas also separate options. These choices appear in a dropdown during registration.",
  "TERMS_DISCLAIMER": "Terms & disclaimer",
  "REMINDERS": "Reminders",
  "REGISTRATION_FEES": "Registration fees",
  "PAID_SERVICE": "Paid\n                Service?",
  "DISCOUNT_POLICY": "Discount Policy",
  "CHOOSE_POLICY": "Choose Policy",
  "NO_DISCOUNT": "No discount",
  "APPLY_THE_LEAST": "Apply the least",
  "APPLY_THE_GREATEST": "Apply the greatest",
  "APPLY_ALL": "Apply all",
  "REGULAR_PRICE_PERSON": "Regular Price / Person",
  "PRICE_EXEMPT_AGE": "Price Exempt Age",
  "SPOT_EXEMPT_AGE": "Spot Exempt Age",
  "MAX_HOUSEHOLD_PAYMENT": "Max Household Payment",
  "MINOR_AGE": "Minor Age",
  "MINOR_DISCOUNT": "Minor Discount $",
  "MINOR_DISCOUNT_5119BD4": "Minor Discount %",
  "SENIOR_DISCOUNT": "Senior Discount $",
  "SENIOR_DISCOUNT_9EE456D": "Senior Discount %",
  "GROUP_COUNT": "Group Count",
  "GROUP_DISCOUNT": "Group Discount $",
  "GROUP_DISCOUNT_0A3C17F": "Group Discount %",
  "EARLYBIRDDATE": "earlyBirdDate",
  "A_VALID_DATE_IS_REQUIRED": "A valid date is required",
  "EARLYBIRD_DISCOUNT": "Earlybird Discount $",
  "EARLYBIRD_DISCOUNT_C156039": "Earlybird Discount %",
  "LEADERS_VOLUNTEERS": "Leaders & volunteers",
  "EDIT_SERVICE": "Edit service",
  "TEXT_PLAN_MONTH": "Text Plan / Month",
  "CURRENT_USAGE": "Current Usage",
  "USAGE_IS_AT": "Usage is at",
  "OR_MORE": "or more.",
  "PLEASE_CONSIDER_UPGRADING_YOUR_PLAN": "Please consider upgrading\n                                your plan!",
  "THIS_ACTION_WILL_DO_THE_FOLLOWING": "This action will do the following",
  "PERMANENTLY_DELETE_YOUR_ACCOUNT": "Permanently delete your account.",
  "PERMANENTLY_DELETE_ALL_YOUR_PERSONAL_INFORMATION_AND_CHECKIN_DETAILS": "Permanently delete all your personal information and checkin details.",
  "YOU_WILL_NOT_BE_ABLE_TO_LOGIN_ANYMORE": "You will not be able to login anymore.",
  "YOU_CAN_STILL_USE_THE_APP_ANONYMOUSLY": "You can still use the app anonymously.",
  "INSTRUCTIONS_TO_DELETE_ACCOUNT": "Instructions to delete account",
  "OPEN_YOUR_PROFILE_CLICK_BELOW": "Open your profile, click below.",
  "OPEN_PROFILE_7234213": "Open profile",
  "IF_PROMPT_LOGIN_TO_YOUR_ACCOUNT": "If prompt, login to your account.",
  "UNDER_ACCOUNT_SETTINGS_CLICK_DELETE_ACCOUNT": "Under Account settings, click Delete account.",
  "REVIEW_THE_WARNING_THEN_SELECT_PERMANENTLY_DELETE_MY_ACCOUNT": "Review the warning, then select Permanently delete my account.",
  "YOUR_ACCOUNT_IS_DELETED_AND_YOU_WILL_BE_LOGGED_OUT": "Your account is deleted, and you will be logged out.",
  "DEPARTMENT_S": "Department(s)",
  "LEADER_AEF43D1": "(leader)",
  "SUPER_GROUP_S": "Super-Group(s)",
  "GROUP_S": "Group(s)",
  "ARE_YOU_SURE_YOU_WOULD_LIKE_TO_REMOVE_THE_BELOW_MEMBER_FROM_THIS_GROUP": "Are you sure you would like to remove the below member from this group?",
  "ADD_GROUP": "Add Group",
  "SCHOOL_GRADE_OFFSET": "School Grade offset",
  "OFFSET_SUCCESSFULLY_APPLIED_IT_MAY_TAKE_UP_TO_60_MIN_TO_REFLECT_IN_GROUP": "Offset successfully applied. It may take up to 60 min to reflect in groups.",
  "CURRENT_TAG_S": "Current Tag(s)",
  "ARE_YOU_SURE_YOU_WOULD_LIKE_TO_REMOVE_THE_BELOW_TAG_FROM_THIS_MEMBER": "Are you sure you would like to remove the below tag from this member?",
  "ADD_TAG": "Add Tag",
  "MEMORIAL_REQUESTS": "Memorial Requests",
  "VACANT": "VACANT",
  "CHECK_IN": "Check-in",
  "EDIT_RESERVATION": "Edit reservation",
  "PRAYER_REQUESTS_91E4C6E": "Prayer requests",
  "MOVE_UP_C66FEB5": "Move up",
  "MOVE_DOWN_40BB50D": "Move down",
  "RERUN": "ReRun",
  "YOUR_EMAIL_ADDRESS_HAS_BEEN_VERIFIED_CONTINUE_TO_YOUR_ACCOUNT": "Your email address has been verified. Continue to your account",
  "THIS_EMAIL_VERIFICATION_LINK_IS_INVALID_OR_HAS_EXPIRED_YOUR_ACCOUNT_AND_": "This email verification link is invalid or has expired. Your account and household are unchanged. Sign in to request a new link.",
  "USERNAME": "Username",
  "WELCOME_BACK": "Welcome back",
  "A_PLACE_TO_BELONG_A_COMMUNITY_TO_GROW_WITH": "A place to belong. A community to grow with.",
  "WORSHIP_COMMUNITY_CONNECTION": "Worship · Community · Connection",
  "SIGN_IN_TO_YOUR_ACCOUNT": "Sign in to your account",
  "WE_RE_GLAD_YOU_RE_HERE": "We’re glad you’re here.",
  "EMAIL_OR_PHONE_NUMBER": "Email or phone number",
  "WE_COULDN_T_SIGN_YOU_IN": "We couldn’t sign you in",
  "VERIFY_EMAIL_OR_RESEND_ACTIVATION_LINK": "Verify email or resend activation link",
  "JUST_VISITING": "Just visiting?",
  "CONTINUE_AS_A_GUEST": "Continue as a guest",
  "FAILED_TO_VERIFY_PHONE": "Failed To Verify Phone!",
  "UNABLE_TO_LOAD_SIGNUP": "Unable to load signup",
  "CHECK_YOUR_CONNECTION_AND_TRY_AGAIN": "Check your connection and try again.",
  "TRY_AGAIN": "Try again",
  "PLEASE_WAIT": "Please wait",
  "CHECK_YOUR_SPAM_FOLDER_TOO": ". Check your spam folder too.",
  "RESEND_VERIFICATION_EMAIL": "Resend verification email",
  "RETURN_TO_CHECK_IN": "Return to check-in",
  "WOULD_YOU_LIKE_TO_ADD_YOUR_HOUSEHOLD_MEMBERS": "Would you like to add your household members?",
  "ADD_YOUR_SPOUSE_CHILDREN_OR_OTHER_HOUSEHOLD_MEMBERS_TO_MAKE_REGISTRATION": "Add your spouse, children, or other household members to make registration and check-in easier.",
  "ADD_HOUSEHOLD_MEMBERS": "Add household members",
  "CONTINUE_TO_APP": "Continue to app",
  "YOU_CAN_ADD_OR_UPDATE_HOUSEHOLD_MEMBERS_ANYTIME_IN_MY_PROFILE": "You can add or update household members anytime in My Profile.",
  "SUBSCRIPTION_LIMIT_HAS_BEEN_REACHED_PLEASE_CONTACT_THE_CHURCH_ADMINISTRA": "Subscription limit has been reached. Please contact the church administrator.",
  "SIGN_IN": "Sign in",
  "COMPLETE_YOUR_CHURCH_S_SIGNUP_REQUIREMENTS_WE_LL_RETURN_YOU_TO_THE_CHECK": "Complete your church’s signup requirements. We’ll return you to the check-in you opened.",
  "WE_RE_GLAD_YOU_RE_HERE_CREATE_YOUR_ACCOUNT_TO_CONNECT_WITH_YOUR_CHURCH_R": "We're glad you're here. Create your account to connect with your church, register for events, and check in.",
  "WE_LL_GUIDE_YOU_THROUGH_YOUR_CONTACT_INFORMATION_PERSONAL_DETAILS_AND_AD": "We'll guide you through your contact information, personal details, and address. You can review everything before creating your account.",
  "CREATE_YOUR_ACCOUNT": "Create your account",
  "ALREADY_HAVE_AN_ACCOUNT": "Already have an account?",
  "REQUIRED": "required",
  "PHONE_COUNTRY_DIALING_CODE": "Phone country / dialing code",
  "PHONE_NUMBER": "Phone number *",
  "NO_TEXT_MESSAGE_IS_REQUIRED_YOUR_PHONE_NUMBER_WILL_REMAIN_UNVERIFIED": "No text message is required. Your phone number will remain unverified.",
  "HELP_YOUR_CHURCH_KEEP_YOUR_INFORMATION_ACCURATE_COMPLETE_THE_FIELDS_REQU": "Help your church keep your information accurate. Complete the fields requested by your church.",
  "PREFERRED_LANGUAGE": "Preferred language",
  "YOUR_PHOTO": "Your photo",
  "YOUR_SELECTED_PROFILE_PHOTO": "Your selected profile photo",
  "REMOVE_PHOTO": "Remove photo",
  "YOU_CAN_ALSO_CHANGE_YOUR_PHOTO_LATER_IN_MY_PROFILE": "You can also change your photo later in My Profile.",
  "ENTER_YOUR_ADDRESS_AND_ANY_ADDITIONAL_INFORMATION_REQUESTED_BY_YOUR_CHUR": "Enter your address and any additional information requested by your church.",
  "PLEASE_CHECK_YOUR_INFORMATION_YOU_CAN_EDIT_ANY_SECTION_BEFORE_CREATING_Y": "Please check your information. You can edit any section before creating your account.",
  "NAME_AND_PHONE": "Name and phone",
  "EDIT_NAME_AND_PHONE": "Edit name and phone",
  "ACCOUNT_ACCESS": "Account access",
  "EDIT_ACCOUNT_ACCESS": "Edit account access",
  "PASSWORD_SET": "Password: Set",
  "ABOUT_YOU": "About you",
  "EDIT_ABOUT_YOU": "Edit about you",
  "YOUR_SELECTED_PHOTO": "Your selected photo",
  "DATE_OF_BIRTH": "Date of birth",
  "MARITAL_STATUS_98D0D2F": "Marital status",
  "PRIMARY_CHURCH": "Primary church",
  "ADDRESS_AND_CHURCH_DETAILS": "Address and church details",
  "EDIT_ADDRESS_AND_CHURCH_DETAILS": "Edit address and church details",
  "RECEIVE_CHURCH_EMAILS": "Receive church emails",
  "YOU_CAN_TURN_TEXT_MESSAGES_AND_EMAILS_OFF_THESE_CHOICES_DO_NOT_PREVENT_Y": "You can turn text messages and emails off. These choices do not prevent you from creating an account.",
  "CHECKING_ACCOUNT_DETAILS": "Checking account details…",
  "PLEASE_CHECK_YOUR_DETAILS": "Please check your details",
  "RESET_PASSWORD_E0EDFEB": "Reset password",
  "CONTINUE": "Continue",
  "CREATE_ACCOUNT": "Create account",
  "YOUR_ACCOUNT_IS_CREATED_ONLY_AFTER_YOU_CONFIRM_THE_FINAL_STEP": "Your account is created only after you confirm the final step.",
  "FIELDS_MARKED_ARE_REQUIRED": "Fields marked * are required.",
  "PHONE_NUMBER_VERIFIED": "Phone number verified.",
  "I_ACKNOWLEDGE_THAT_I_HAVE_READ_AND_AGREE_TO_THE_PRIVACY_POLICY": "I acknowledge that I have read and agree to the Privacy Policy.",
  "READ_THE_PRIVACY_POLICY": "Read the Privacy Policy",
  "ONE_LAST_STEP_TURN_ON_THE_PRIVACY_POLICY_ACKNOWLEDGMENT_ABOVE_TO_CREATE_": "One last step: turn on the Privacy Policy acknowledgment above to create your account.",
  "PLEASE_ENTER_YOUR_CELL_PHONE_NUMBER": "Please enter your cell phone number",
  "UNABLE_TO_LOAD_YOUR_HOUSEHOLD": "Unable to load your household",
  "CHECK_YOUR_CONNECTION_AND_TRY_AGAIN_OR_VERIFY_YOUR_PHONE_NUMBER": "Check your connection and try again, or verify your phone number.",
  "VERIFY_PHONE_F351A80": "Verify phone",
  "VERIFY_YOUR_EMAIL_ONCE_WE_LL_REMEMBER_THIS_DEVICE_FOR_QUICK_CHECK_IN": "Verify your email once. We’ll remember this device for quick check-in.",
  "CONTINUE_BY_EMAIL": "Continue by email",
  "SIGN_IN_WITH_PASSWORD": "Sign in with password",
  "SELECT_THE_ATTENDEES_THEN_TAP_CHECK_IN": "Select the attendees, then tap Check-In.",
  "BY_CHECKING_IN_YOU_AGREE_TO_THE_CHURCH_SERVICES": "By checking in, you agree to the Church Services",
  "TERMS_OF_USE": "Terms of Use",
  "YOUR_IDENTITY_HAS_BEEN_SUCCESSFULLY_VERIFIED": "Your identity has been successfully verified.",
  "CLOSE_NAVIGATION": "Close navigation",
  "V26_06": "v26.06",
  "MAIN_NAVIGATION": "Main navigation",
  "SIGN_OUT_AND_FORGET_THIS_DEVICE": "Sign out and forget this device",
  "PERSONAL": "Personal",
  "RESERVATIONS": "Reservations",
  "OUTREACH_TASKS": "Outreach tasks",
  "SWITCH_CHURCH": "Switch church",
  "SIGN_OUT": "Sign out",
  "PRIVACY": "Privacy",
  "PAYMENT_FAILED": "Payment Failed",
  "WE_WERE_UNABLE_TO_VERIFY_YOUR_PAYMENT": "We were unable to verify your payment.",
  "IF_YOUR_CARD_WAS_CHARGED_PLEASE_CONTACT_THE_CHURCH_ADMINISTRATOR": "If your card was charged, please contact the church administrator.",
  "YOU_MAY_ALSO_RETURN_TO_THE_FORM_AND_TRY_AGAIN": "You may also return to the form and try again.",
  "PAYMENT_SUCCESSFUL": "Payment Successful",
  "YOUR_PAYMENT_HAS_BEEN_RECEIVED_AND_YOUR_FORM_WAS_SUCCESSFULLY_SUBMITTED": "Your payment has been received and your form was successfully submitted.",
  "CONFIRMATION_NUMBER": "Confirmation Number:",
  "A_CONFIRMATION_EMAIL_WILL_BE_SENT_IF_CONFIGURED_BY_THE_CHURCH": "A confirmation email will be sent if configured by the church.",
  "YOUR_ACCOUNT_HAS_BEEN_DELETED": "Your account has been deleted.",
  "YOU_CAN_CONTINUE_ENJOYING_CHURCH_SERVICES_ANNOUNCEMENTS_AND_SERMONS_AS_A": "You can continue enjoying church services, announcements, and sermons as a guest.",
  "DISMISS_ACCOUNT_DELETION_CONFIRMATION": "Dismiss account deletion confirmation",
  "DISMISS": "Dismiss",
  "TO_REPORT_ABUSE_RELATED_TO_THIS_APP_PLEASE_EMAIL": "To report abuse related to this app please email:",
  "NASHWA_ABUALSAAD_CHURCH_SERVICES_ORG": "nashwa.abualsaad@church-services.org",
  "VIEW_THE_EVENTS_AND_SCHEDULE_FOR": "View the events and schedule for",
  "OPEN_CHURCH_CALENDAR": "Open church calendar",
  "UNABLE_TO_OPEN_THE_CALENDAR_PLEASE_TRY_AGAIN": "Unable to open the calendar. Please try again.",
  "PREVIEW_STATEMENT": "Preview Statement",
  "ACCOUNT_SETTINGS": "Account settings",
  "DELETE_YOUR_ACCOUNT_PERMANENTLY_YOU_CAN_STILL_USE_PUBLIC_CHURCH_FEATURES": "Delete your account permanently. You can still use public church features as a guest.",
  "DELETE_ACCOUNT_A2E20A3": "Delete account",
  "PERMANENTLY_DELETE_YOUR_ACCOUNT_79594F2": "Permanently delete your account?",
  "YOUR_ACCOUNT_COULD_NOT_BE_DELETED": "Your account could not be deleted",
  "DELETING_YOUR_ACCOUNT": "Deleting your account",
  "PLEASE_WAIT_WHILE_WE_REMOVE_YOUR_ACCOUNT_AND_ASSOCIATED_CHURCH_RECORDS_T": "Please wait while we remove your account and associated church records. This can take a little time.",
  "YOUR_ACCOUNT_HAS_BEEN_DELETED_DED8C71": "Your account has been deleted",
  "YOU_CAN_CONTINUE_USING_PUBLIC_CHURCH_FEATURES_AS_A_GUEST": "You can continue using public church features as a guest.",
  "CONTINUE_AS_GUEST": "Continue as guest",
  "TAX_STATEMENT_E9F1B96": "TAX STATEMENT",
  "CONTRIBUTOR_NAME": "Contributor Name:",
  "TO_2B5FC5C": "To:",
  "TAX_ID_D745456": "- TAX ID:",
  "CONTRIBUTION_PERIOD": "Contribution Period:",
  "TOTAL_CONTRIBUTION": "Total Contribution:",
  "NO_GOODS_OR_SERVICES_WERE_PROVIDED_IN_EXCHANGE_OF_YOUR_CONTRIBUTIONS_LIS": "No goods or services were provided in exchange of your contributions listed below:",
  "FUND": "Fund",
  "THANK_YOU_FOR_YOUR_CONTRIBUTION": "Thank you for your contribution.",
  "TREASURER": "Treasurer",
  "DOWNLOAD_AS_PDF": "Download As PDF",
  "SHOW_ON_MAP_6F03881": "Show On Map",
  "CHURCH_HEADER": "Church header",
  "GO_BACK": "Go back",
  "THIS_PAGE_WAS_NOT_FOUND": "This page was not found",
  "THIS_CHURCH_IS_NO_MORE_AVAILABLE": "This church is no more available",
  "YOU_ARE_NOT_AUTHORIZED_TO_ACCESS_THIS_PAGE": "You are not authorized to access this page!",
  "SIMILAR_RECORDS_DETECTED_ARE_THOSE_ONE_PERSON": "Similar records detected. Are those one person?",
  "CHOOSE_WHICH_RECORD_TO_KEEP_THEN_CLICK_MERGE": "Choose which record to keep then click Merge.",
  "MERGE": "Merge",
  "CANCEL_19766ED": "Cancel",
  "ARE_YOU_SURE_THOSE_ARE_TWO_DIFFERENT_PERSONS": "Are you sure those are two different persons?",
  "INVITATIONS_TO_JOIN_GROUP_S": "Invitations to join group(s)",
  "LATER": "Later",
  "UNABLE_TO_LOAD_NOTIFICATIONS": "Unable to load notifications.",
  "THIS_CHECK_IN_LINK_IS_UNAVAILABLE": "This check-in link is unavailable",
  "PLEASE_TAP_OR_SCAN_THE_CHURCH_S_CHECK_IN_LINK_AGAIN_OR_ASK_AN_USHER_FOR_": "Please tap or scan the church’s check-in link again, or ask an usher for help.",
  "LOADING_YOUR_HOUSEHOLD": "Loading your household…",
  "START_AGAIN": "Start again",
  "AN_USHER_CAN_HELP": "An usher can help",
  "IF_YOU_CANNOT_RECEIVE_A_VERIFICATION_TEXT_OR_YOUR_HOUSEHOLD_IS_NOT_LISTE": "If you cannot receive a verification text or your household is not listed, ask an usher to help you check in.",
  "BACK_TO_CHECK_IN": "Back to check-in",
  "WELCOME_TO_CHECK_IN": "Welcome to check-in",
  "SIGN_IN_OR_VERIFY_YOUR_EMAIL_ONCE_WE_LL_AUTOMATICALLY_REMEMBER_THIS_DEVI": "Sign in or verify your email once. We’ll automatically remember this device for future check-ins.",
  "NEW_HERE_CREATE_AN_ACCOUNT": "New here? Create an account",
  "LET_S_GET_YOU_CHECKED_IN": "Let’s get you checked in",
  "ENTER_YOUR_MOBILE_NUMBER_WE_LL_SEND_A_CODE_TO_VERIFY_IT_AND_FIND_YOUR_HO": "Enter your mobile number. We’ll send a code to verify it and find your household.",
  "CAN_T_RECEIVE_A_TEXT": "Can’t receive a text?",
  "PHONE_VERIFIED_4D4FD46": "Phone verified",
  "WELCOME_TO_YOUR_CHURCH": "Welcome to your church",
  "WE_COULDN_T_FIND_AN_ACCOUNT_FOR_THIS_VERIFIED_NUMBER_CREATE_AN_ACCOUNT_T": "We couldn’t find an account for this verified number. Create an account to check in and manage your household.",
  "YOUR_VERIFIED_PHONE_NUMBER_WILL_CARRY_OVER_AFTER_SIGNUP_WE_LL_RETURN_YOU": "Your verified phone number will carry over. After signup, we’ll return you to this check-in.",
  "CONTINUE_TO_SIGNUP": "Continue to signup",
  "USE_ANOTHER_NUMBER": "Use another number",
  "ASK_AN_USHER_FOR_HELP": "Ask an usher for help",
  "YOUR_HOUSEHOLD": "Your household",
  "WHO_S_HERE_TODAY": "Who’s here today?",
  "SELECT_EVERYONE_ATTENDING_THEN_CHECK_IN_ONCE": "Select everyone attending, then check in once.",
  "SELECTED_D7CBBB6": "selected",
  "CLEAR_SELECTION": "Clear selection",
  "SELECT_EVERYONE": "Select everyone",
  "YOU": "You",
  "CHECK_IN_20E82B4": "Check in",
  "CHECK_IN_DID_NOT_COMPLETE": "Check-in did not complete",
  "NOT_YOUR_HOUSEHOLD_FORGET_THIS_DEVICE": "Not your household? Forget this device",
  "YOU_RE_CHECKED_IN": "You’re checked in",
  "ATTENDEES_CONFIRMED": "attendees confirmed",
  "CHECKING_IN": "Checking in…",
  "SELECT_ATTENDEES_753D22C": "Select attendees",
  "UNRECOGNIZED_CHURCH_ID": "Unrecognized Church ID",
  "PREVIOUSLY_VISITED": "Previously visited",
  "UNABLE_TO_CONNECT_PLEASE_TRY_AGAIN": "Unable to connect. Please try again.",
  "CHECK_IN_A2BEE91": "Check-In",
  "RESET": "Reset",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TRANSACTION": "Are you sure you want to delete this transaction?",
  "ARE_YOU_SURE_YOU_WANT_TO_RESTORE_THIS_TRANSACTION": "Are you sure you want to restore this transaction?",
  "4_DIGITS_CODE": "4 digits code",
  "ENTER_PRAYER": "Enter Prayer",
  "ENTER_DEPARTED_SOULS": "Enter Departed Souls",
  "REGISTERED": "Registered",
  "CLOSE_310FF20": "close",
  "PREVIOUS_WEEK": "Previous week",
  "NEXT_WEEK": "Next week",
  "UPCOMING_EVENTS": "Upcoming events",
  "RECIPIENT_LEVEL": "Recipient Level",
  "ALL_PEOPLE": "All People",
  "CHURCH_MEMBERS": "Church Members",
  "CHURCH_GUESTS": "Church Guests",
  "GROUP_COLLECTION": "Group Collection",
  "RECIPIENT_DETAILS": "Recipient Details",
  "ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEMPLATE": "Are you sure you want to delete this template?",
  "SUBJECT": "Subject",
  "SUBTITLE": "Subtitle",
  "BODY": "Body",
  "OPEN_RICH_EDITOR": "Open Rich Editor",
  "MONTHLY_TEXT_PACKAGE_DOESN_T_ALLOW_THIS_BATCH_PLEASE_REDUCE_YOUR_SELECTI": "Monthly text package doesn't allow this batch. Please reduce your selection or upgrade text plan.",
  "LOADING_CHURCH_SERVICES": "Loading Church Services",
  "LOADING_MAP": "Loading map...",
  "NO_VALID_ADDRESSES_SELECTED": "No valid addresses selected!",
  "LAST_WEEK": "Last Week",
  "LAST_2_WEEKS": "Last 2 Weeks",
  "LAST_3_WEEKS": "Last 3 Weeks",
  "LAST_MONTH": "Last Month",
  "LAST_3_MONTHS": "Last 3 Months",
  "LAST_6_MONTHS": "Last 6 Months",
  "LAST_YEAR": "Last Year",
  "LAST_5_YEARS": "Last 5 Years",
  "CUSTOM": "Custom",
  "TIMES": "Times",
  "CONTACT": "Contact",
  "CHURCH_GROUPS": "Church & groups",
  "ADMIN": "Admin",
  "ATTENDANCE_VIEWER": "Attendance Viewer",
  "CMS_ADMINISTRATOR": "CMS Administrator",
  "EVENT_ORGANIZER": "Event Organizer",
  "EVENT_VIEWER": "Event Viewer",
  "FORM_ADMIN": "Form Admin",
  "FORM_EDITOR": "Form Editor",
  "FORM_VIEWER": "Form Viewer",
  "FULL_PROFILE_FOR_LEADERS": "Full Profile for Leaders",
  "GROUP_ADMIN": "Group Admin",
  "MEMBERSHIP_MANAGEMENT_7122C4D": "Membership Management",
  "NOTE_PRIVACY": "Note Privacy",
  "NOTES_FULL_ACCESS": "Notes Full Access",
  "NOTES_LIMITED_ACCESS": "Notes Limited Access",
  "OUTREACH_PRIVACY": "Outreach Privacy",
  "PROFILE_EDITOR": "Profile Editor",
  "PROFILE_VIEWER": "Profile Viewer",
  "REGISTRATION_EXEMPT": "Registration Exempt",
  "SERVICE_LEADER": "Service Leader",
  "TASK_ASSIGNMENT": "Task Assignment",
  "VOLUNTEER_LEADER": "Volunteer Leader",
  "VOLUNTEERING_ADMIN": "Volunteering Admin",
  "ANY_BUT_LEADER": "Any but leader",
  "DISMISS_MESSAGE": "Dismiss message",
  "DIALING_CODE": "Dialing code",
  "FAILED_TO_VERIFY_818C2AF": "Failed To Verify",
  "MOBILE_NUMBER": "Mobile number",
  "SENDING_CODE": "Sending code…",
  "SEND_VERIFICATION_CODE": "Send verification code",
  "ENTER_YOUR_CODE": "Enter your code",
  "WE_SENT_A_FOUR_DIGIT_CODE_TO": "We sent a four-digit code to",
  "CHANGE_NUMBER": "Change number",
  "VERIFICATION_CODE": "Verification code",
  "A_NEW_CODE_HAS_BEEN_SENT": "A new code has been sent.",
  "VERIFYING": "Verifying…",
  "VERIFY_CONTINUE": "Verify & continue",
  "RESEND_CODE_IN": "Resend code in",
  "S": "s",
  "RESEND_CODE": "Resend code",
  "WELCOME_YOUR_ACCOUNT_IS_SAVED_ADD_YOUR_HOUSEHOLD_MEMBERS_NOW_OR_CONTINUE": "Welcome! Your account is saved. Add your household members now, or continue to the app.",
  "CHOOSE_WHOSE_INFORMATION_TO_EDIT_OR_ADD_A_HOUSEHOLD_MEMBER": "Choose whose information to edit, or add a household member.",
  "HOUSEHOLD_DUPLICATE_REVIEW": "Household duplicate review",
  "POSSIBLE_DUPLICATE_HOUSEHOLD_MEMBERS": "Possible duplicate household members",
  "THESE_RECORDS_MAY_DESCRIBE_THE_SAME_PERSON_REVIEW_THEM_NOW_OR_CONTINUE_A": "These records may describe the same person. Review them now, or continue and return later. Combining keeps both parents linked and preserves church records.",
  "SAME_PERSON_COMBINE_RECORDS": "Same person — combine records",
  "DIFFERENT_PEOPLE": "Different people",
  "REVIEW_LATER": "Review later",
  "PHONE_NUMBER_306F1BB": "Phone number",
  "THIS_CHURCH_USES_EMAIL_VERIFICATION_NO_TEXT_MESSAGE_IS_REQUIRED": "This church uses email verification. No text message is required.",
  "RECEIVE_TEXT_MESSAGES": "Receive text messages",
  "RECEIVE_EMAILS": "Receive emails",
  "PLEASE_CHECK_YOUR_INBOX_FOR_AN_ACCOUNT_ACTIVATION_EMAIL": "Please check your inbox for an account activation email.",
  "CHECK_REQUIRED_FIELDS": "Check Required Fields!",
  "CANCEL_EDITING": "Cancel editing",
  "DELETE_HOUSEHOLD_MEMBER": "Delete household member?",
  "PHOTO_CHANGES_ARE_SAVED_WHEN_YOU_TAP_SAVE": "Photo changes are saved when you tap Save.",
  "SAME_PERSON_USE_THIS_RECORD": "Same person — use this record",
  "DIFFERENT_PEOPLE_CREATE_A_NEW_RECORD": "Different people — create a new record",
  "CREATE_NOW_REVIEW_LATER": "Create now, review later",
  "SUBSCRIPTION_LIMIT_HAS_BEEN_REACHED_PLEASE_CONTACT_THE_CHURCH_ADMIN": "Subscription limit has been reached. Please contact the church admin.",
  "DISCARD_YOUR_CHANGES": "Discard your changes?",
  "MEMBERSHIP_DE0799A": "MEMBERSHIP",
  "SERVICES_019C527": "SERVICES",
  "FORMS_EB63641": "FORMS",
  "VOLUNTEERING_AEBA9EE": "VOLUNTEERING",
  "CONTENT_MANAGEMENT_6549D86": "CONTENT_MANAGEMENT",
  "SETTINGS": "Settings",
  "SUPER_ADMIN_FD7280E": "SUPER_ADMIN",
  "CONGREGATION_CHECK_IN": "Congregation check-in",
  "IS_TASK_COMPLETE": "Is Task Complete?",
  "RECORD_IN_ACTIVITY_HISTORY": "Record in Activity History?",
  "EDIT_TASK": "Edit\n        Task",
  "MEMBER_TOOLS": "Member tools",
  "CALL_D6E645B": "Call",
  "TEXT_SMS": "Text (SMS)",
  "NOTES_AVAILABLE": "Notes available",
  "ADD_PRIVATE_NOTE": "Add private note",
  "VIEW_PRIVATE_NOTES": "View private notes",
  "EDIT_POINTS_CCCBDFE": "Edit points",
  "EDIT_DONATIONS": "Edit donations",
  "DONATION_ACCOUNTS": "Donation accounts",
  "ACTIVITY_OUTREACH": "Activity & outreach",
  "ACTIVITY_HISTORY": "Activity history",
  "ACTIVITY_CHART_CAAED6C": "Activity chart",
  "OUTREACH_HISTORY": "Outreach history",
  "DIRECTIONS_C953567": "Directions",
  "ADD_REMINDER": "Add reminder",
  "RECORD_OUTREACH": "Record outreach",
  "ASSIGN_OUTREACH": "Assign outreach",
  "FAMILY_CONTACTS": "Family contacts",
  "LOADING_FAMILY_CONTACTS": "Loading family contacts…",
  "PRIMARY_CONTACT": "Primary contact",
  "CONTACT_ACTIONS_FOR": "Contact actions for",
  "MAKE_PRIMARY_CONTACT": "Make primary contact",
  "UPDATING_PRIMARY_CONTACT": "Updating primary contact…",
  "MAKE_PRIMARY": "Make primary",
  "BY_CHECKING_IN_YOU_AGREE_TO_CHURCH_SERVICES_TERMS": "By Checking in, you agree to Church Services terms.",
  "THANK_YOU_47AD4E1": "Thank you!!",
  "OK": "OK",
  "WELCOME_TO_CHURCH_SERVICES": "Welcome to Church Services!",
  "SCAN_ME_TO_SIGN_UP": "Scan me to Sign Up",
  "DELETE_COMPONENT_8143E08": "Delete component?",
  "RESTORE_COMPONENT": "Restore component?",
  "FONT_AWESOME_5": "font_awesome_5",
  "RTL": "RTL",
  "LTR": "LTR",
  "EMAIL_ADDRESS": "Email Address",
  "STREET_ADDRESS": "Street Address",
  "ZIP_7BC88EB": "Zip",
  "MARITAL_STATUS_2D2FF71": "Marital Status",
  "DATA_VIEW": "Data View",
  "UNABLE_TO_DELETE_THIS_SUBMISSION_PLEASE_TRY_AGAIN": "Unable to delete this submission. Please try again.",
  "ERROR_NUMBER_OF_SUBMISSIONS_REACHED": "Error: Number of Submissions Reached",
  "FAILED_TO_SUBMIT_FORM": "Failed to Submit Form!",
  "UNABLE_TO_COPY_PAYMENT_LINK_TO_CLIPBOARD": "Unable to copy payment link to clipboard.",
  "PAYMENT_LINK_CREATED_USE_THE_COPY_BUTTON_TO_COPY_IT_TO_THE_CLIPBOARD": "Payment link created. Use the Copy button to copy it to the clipboard.",
  "EDIT_PAYMENT_ADAPTER": "Edit Payment Adapter",
  "UNABLE_TO_DELETE_THIS_ACTIVITY_PLEASE_TRY_AGAIN": "Unable to delete this activity. Please try again.",
  "SIGN_IN_TO_CHECK_IN": "Sign in to check in",
  "ACTIVATE_YOUR_ACCOUNT": "Activate your account",
  "ENTER_YOUR_EMAIL_AND_WE_LL_GUIDE_YOU_TO_THE_NEXT_STEP_AFTER_SUCCESSFUL_L": "Enter your email and we’ll guide you to the next step. After successful login or verification, this device is remembered for quick check-in.",
  "VERIFY_AND_CONTINUE": "Verify and continue",
  "EMAIL_ADDRESS_F2488FD": "Email address",
  "FORGOT_PASSWORD": "Forgot password",
  "RESEND_ACTIVATION_EMAIL_A9A342E": "Resend activation email",
  "REQUEST_A_NEW_LINK": "Request a new link",
  "PLEASE_SIGN_IN_TO_CONTINUE_TO_CHECK_IN_YOUR_EMAIL_HAS_NOT_BEEN_VERIFIED_": "Please sign in to continue to check-in. Your email has not been verified. No email was sent. We’ll remember this device after login.",
  "YOUR_NEW_ACCOUNT_NEEDS_EMAIL_ACTIVATION_BEFORE_ITS_FIRST_LOGIN_YOU_CAN_R": "Your new account needs email activation before its first login. You can resend the activation link below.",
  "WE_COULD_NOT_FIND_AN_ACCOUNT_FOR_THIS_EMAIL_CREATE_AN_ACCOUNT_OR_USE_ANO": "We could not find an account for this email. Create an account or use another address.",
  "CONTACT_YOUR_CHURCH_FOR_ACCOUNT_ASSISTANCE_AN_USHER_CAN_HELP_RECORD_YOUR": "Contact your church for account assistance. An usher can help record your attendance.",
  "UNABLE_TO_SEND_EMAIL_TRY_AGAIN": "Unable to send email. Try again.",
  "EMAIL_VERIFIED_YOUR_ACCOUNT_IS_ACTIVE_AND_THIS_DEVICE_IS_READY_FOR_QUICK": "Email verified. Your account is active and this device is ready for quick check-in. Sign in to manage your account.",
  "THIS_LINK_IS_INVALID_OR_EXPIRED_REQUEST_A_NEW_ONE": "This link is invalid or expired. Request a new one.",
  "ADD_AND_VERIFY_AN_EMAIL_ADDRESS_SO_YOU_CAN_RECOVER_YOUR_ACCOUNT_IF_YOU_F": "Add and verify an email address so you can recover your account if you forget your password.",
  "KEEP_YOUR_ACCOUNT_RECOVERABLE": "Keep your account recoverable",
  "ADD_OR_VERIFY_EMAIL": "Add or verify email",
  "PLEASE_CHECK_YOUR_CONNECTION": "Please check your connection!",
  "AWAITING_VERIFICATION_YOUR_CURRENT_EMAIL_STAYS_ACTIVE": "· Awaiting verification. Your current email stays active.",
  "THE_LINK_EXPIRED_REQUEST_A_NEW_ONE": "The link expired; request a new one.",
  "CHANGE_EMAIL": "Change email",
  "CANCEL_CHANGE": "Cancel change",
  "REMIND_ME_LATER": "Remind me later",
  "EMAIL_CHANGE_CANCELLED_YOUR_CURRENT_EMAIL_IS_UNCHANGED": "Email change cancelled. Your current email is unchanged.",
  "UNABLE_TO_CANCEL_THE_CHANGE_PLEASE_TRY_AGAIN": "Unable to cancel the change. Please try again.",
  "VERIFICATION_LINK_SENT_PLEASE_CHECK_YOUR_INBOX_AND_SPAM_FOLDER": "Verification link sent. Please check your inbox and spam folder.",
  "UNABLE_TO_RESEND_RIGHT_NOW_PLEASE_TRY_AGAIN_SHORTLY": "Unable to resend right now. Please try again shortly.",
  "UNABLE_TO_SIGN_IN_RIGHT_NOW_PLEASE_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN": "Unable to sign in right now. Please check your connection and try again.",
  "ENTER_YOUR_VERIFIED_EMAIL_ADDRESS_TO_RESET_YOUR_PASSWORD": "Enter your verified email address to reset your password.",
  "ENTER_A_VALID_PHONE_NUMBER_WITHOUT_THE_DIALING_CODE": "Enter a valid phone number without the dialing code.",
  "PLEASE_ADD_YOUR_PROFILE_PICTURE": "Please add your profile picture.",
  "PLEASE_CHECK_THE_HIGHLIGHTED_FIELDS_BEFORE_CONTINUING": "Please check the highlighted fields before continuing.",
  "PLEASE_VERIFY_YOUR_PHONE_NUMBER_BEFORE_CONTINUING": "Please verify your phone number before continuing.",
  "ACCOUNT_EXISTS_1445596": "ACCOUNT_EXISTS",
  "PLEASE_VERIFY_YOUR_PHONE_NUMBER_WITH_THE_SELECTED_DIALING_CODE": "Please verify your phone number with the selected dialing code.",
  "PLEASE_VERIFY_YOUR_PHONE_AGAIN_TO_FINISH_CREATING_YOUR_ACCOUNT_YOUR_OTHE": "Please verify your phone again to finish creating your account. Your other information is still here.",
  "VERIFY_PHONE_ERROR_A4CA52F": "VERIFY_PHONE_ERROR",
  "PLEASE_VERIFY_YOUR_PHONE_AGAIN_YOUR_OTHER_INFORMATION_IS_STILL_HERE": "Please verify your phone again. Your other information is still here.",
  "CONNECTION_ERROR_DC90844": "CONNECTION_ERROR",
  "UNABLE_TO_SEND_THE_LINK_PLEASE_TRY_AGAIN": "Unable to send the link. Please try again.",
  "IDENTITY_VERIFICATION": "Identity Verification",
  "UNABLE_TO_FORGET_THIS_DEVICE_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN": "Unable to forget this device. Check your connection and try again.",
  "ERROR_REACHED_MAXIMUM_CAPACITY": "Error: Reached maximum capacity",
  "ACCOUNT_FOUND_AND_ADDED": "Account found and added!",
  "ERROR_FAILED_TO_JOIN_THE_GROUP": "Error: Failed to join the group!",
  "MY_PROFILE_HOUSEHOLD": "My profile & household",
  "UNABLE_TO_LOAD_CHECK_IN_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN": "Unable to load check-in. Check your connection and try again.",
  "CHECK_YOUR_CONNECTION_AND_TRY_AGAIN_YOUR_HOUSEHOLD_COULD_NOT_BE_LOADED": "Check your connection and try again. Your household could not be loaded.",
  "PLEASE_VERIFY_YOUR_PHONE_AGAIN_TO_CONTINUE": "Please verify your phone again to continue.",
  "WE_COULD_NOT_IDENTIFY_YOUR_HOUSEHOLD_PLEASE_VERIFY_YOUR_PHONE_AGAIN": "We could not identify your household. Please verify your phone again.",
  "CHECK_IN_DID_NOT_COMPLETE_YOUR_SELECTION_IS_STILL_HERE_PLEASE_TRY_AGAIN": "Check-in did not complete. Your selection is still here. Please try again.",
  "ERROR_THIS_DONATION_IS_READ_ONLY_AND_CANNOT_BE_UPDATED": "Error: This donation is read-only and cannot be updated!",
  "RECORD_SAVED_SUCCESSFULLY": "Record saved successfully!",
  "AMOUNT_CANNOT_BE_0": "Amount cannot be 0",
  "RECORD_ADDED_SUCCESSFULLY": "Record added successfully!",
  "NG_CALENDAR_DEMO": "ng-calendar-demo",
  "FIND_YOUR_ADDRESS": "Find your address",
  "START_TYPING_AND_CHOOSE_A_SUGGESTION_OR_ENTER_YOUR_ADDRESS_IN_THE_FIELDS": "Start typing and choose a suggestion, or enter your address in the fields below. Change Country below to search elsewhere.",
  "START_TYPING_YOUR_STREET_ADDRESS": "Start typing your street address",
  "ADDRESS_SEARCH_IS_UNAVAILABLE_RIGHT_NOW_YOU_CAN_ENTER_YOUR_ADDRESS_BELOW": "Address search is unavailable right now. You can enter your address below.",
  "GETTING_YOUR_ADDRESS": "Getting your address…",
  "PLEASE_CHOOSE_A_STREET_ADDRESS_IN_YOUR_SELECTED_COUNTRY_OR_ENTER_IT_BELO": "Please choose a street address in your selected country, or enter it below.",
  "ADDRESS_FILLED_IN_PLEASE_CHECK_THE_DETAILS_BELOW_AND_ADD_AN_APARTMENT_OR": "Address filled in. Please check the details below and add an apartment or unit number if needed.",
  "CHECKING_YOUR_ADDRESS": "Checking your address…",
  "ADDRESS_FOUND": "Address found.",
  "WE_LL_USE_THE_ADDRESS_YOU_ENTERED": "We'll use the address you entered.",
  "WE_COULDN_T_CHECK_YOUR_ADDRESS_RIGHT_NOW_PLEASE_CHECK_IT_THEN_TRY_AGAIN_": "We couldn't check your address right now. Please check it, then try again or keep the address you entered.",
  "IS_THIS_YOUR_ADDRESS": "Is this your address?",
  "WE_FOUND_A_POSSIBLE_MATCH_PLEASE_CHECK_IT_BEFORE_CONTINUING": "We found a possible match. Please check it before continuing.",
  "USE_SUGGESTED_ADDRESS": "Use suggested address",
  "COULD_YOU_CHECK_YOUR_ADDRESS": "Could you check your address?",
  "WE_COULDN_T_FIND_A_CLEAR_MATCH_THAT_S_OKAY_SOME_ADDRESSES_AREN_T_LISTED_": "We couldn't find a clear match. That's okay—some addresses aren't listed. Check for typos, or keep the address you entered.",
  "EDIT_MY_ADDRESS": "Edit my address",
  "KEEP_ENTERED_ADDRESS": "Keep entered address",
  "CONFIRM_ACTION": "Confirm action",
  "ACTION_NEEDED": "Action needed",
  "ENTER_A_VALID_MOBILE_NUMBER_WITH_THE_SELECTED_DIALING_CODE": "Enter a valid mobile number with the selected dialing code.",
  "AN_ACCOUNT_ALREADY_EXISTS_SIGN_IN_OR_RESET_YOUR_PASSWORD_BELOW": "An account already exists. Sign in or reset your password below.",
  "NO_ACCOUNT_IS_ASSOCIATED_WITH_THIS_PHONE_NUMBER": "No account is associated with this phone number.",
  "WE_COULD_NOT_SEND_A_TEXT_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN": "We could not send a text. Check your connection and try again.",
  "UNABLE_TO_SEND_THE_CODE_PLEASE_TRY_AGAIN": "Unable to send the code. Please try again.",
  "ENTER_THE_FOUR_DIGIT_CODE_FROM_YOUR_TEXT_MESSAGE": "Enter the four-digit code from your text message.",
  "UNABLE_TO_VERIFY_THE_CODE_PLEASE_TRY_AGAIN": "Unable to verify the code. Please try again.",
  "PHONE_VERIFIED_1BF655D": "PHONE_VERIFIED",
  "VERIFYPHONE_TO_SAVE_47CDCAA": "VERIFYPHONE_TO_SAVE",
  "CHECK_YOUR_NEW_EMAIL_TO_CONFIRM_THE_CHANGE_YOUR_PREVIOUS_ADDRESS_REMAINS": "Check your new email to confirm the change. Your previous address remains active until verification.",
  "PROFILE_UPDATED_318AFD3": "PROFILE_UPDATED",
  "SIGNUP_PROFILE_FIELDS": "Signup & profile fields",
  "CHOOSE_WHAT_YOUR_CHURCH_COLLECTS_SECTION_CONTROLS_APPLY_TO_EVERY_FIELD_B": "Choose what your church collects. Section controls apply to every field below; you can then adjust individual fields.",
  "ALWAYS_AVAILABLE_AND_REQUIRED": "Always available and required",
  "FIRST_NAME_LAST_NAME_VERIFIED_CELL_PHONE_AND_DIALING_CODE_PRIMARY_CHURCH": "First name, last name, verified cell phone and dialing code, primary church selection, and communication choices. Password is required during signup. People can choose to disable communication.",
  "HIDING_A_FIELD_PRESERVES_INFORMATION_ALREADY_SAVED_CHANGES_APPLY_TO_THIS": "Hiding a field preserves information already saved. Changes apply to this church only.",
  "LEFT_TO_RIGHT": "Left to Right",
  "RIGHT_TO_LEFT": "Right to Left",
  "PRIMARY_CONTACT_UPDATED": "Primary contact updated.",
  "WE_COULD_NOT_CONFIRM_THE_CHANGE_PLEASE_TRY_AGAIN": "We could not confirm the change. Please try again.",
  "FAMILY_CONTACTS_COULD_NOT_BE_LOADED_PLEASE_TRY_AGAIN": "Family contacts could not be loaded. Please try again.",
  "ADDITIONAL_LANGUAGES": "Additional languages",
  "ADD_ANOTHER_LANGUAGE": "Add another language",
  "LANGUAGE_SAVE_FAILED": "Unable to save your language preference. Please try again.",
  "PUSHPAY_HOSTED_PAYMENTS_DO_NOT_REQUIRE_AN_API_CONNECTION_CHURCH_SERVICES_6B6F4B3": "Pushpay hosted payments do not require an API connection.\n\n              Church Services can redirect donors directly to your Pushpay\n\n              giving page.",
  "HOSTED_PUSHPAY_PAYMENTS_WORK_WITHOUT_AN_API_CONNECTION_CONNECT_YOUR_PUSH_E6E9DA7": "Hosted Pushpay payments work without an API connection.\n\n                Connect your Pushpay account if you have API access and want\n\n                Church Services to verify payments directly with Pushpay.",
  "ACCOUNT_CLICK_ABDF89C": "account.\n\n\n\n            Click",
  "BELOW_TO_AUTHORIZE_CHURCH_SERVICES_TO_PROCESS_PAYMENTS_ON_BEHALF_OF_YOUR_3015F81": "below to authorize Church Services to process\n\n            payments on behalf of your organization.",
  "PLEASE_CONSIDER_UPGRADING_YOUR_PLAN_3675E56": "Please consider upgrading\n\n                                your plan!",
  "EDIT_TASK_CB53B52": "Edit\n\n        Task",
  "NOTHING_TO_SHOW_YET": "Nothing to show yet",
  "ITEMS_WILL_APPEAR_HERE_WHEN_THEY_ARE_AVAILABLE": "Items will appear here when they are available.",
  "NO_NOTIFICATIONS_YET": "No notifications yet",
  "NEW_CHURCH_NOTIFICATIONS_AND_REMINDERS_WILL_APPEAR_HERE": "New church notifications and reminders will appear here.",
  "SIGN_IN_TO_VIEW_NOTIFICATIONS": "Sign in to view notifications",
  "YOUR_NOTIFICATIONS_ARE_AVAILABLE_AFTER_YOU_SIGN_IN": "Your notifications are available after you sign in.",
  "NO_RESERVATIONS_YET": "No reservations yet",
  "YOUR_EVENT_RESERVATIONS_WILL_APPEAR_HERE_AFTER_YOU_RESERVE_A_PLACE": "Your event reservations will appear here after you reserve a place.",
  "NO_GROUPS_TO_SHOW": "No groups to show",
  "YOUR_HOUSEHOLD_S_GROUPS_AND_INVITATIONS_WILL_APPEAR_HERE_WHEN_AVAILABLE": "Your household’s groups and invitations will appear here when available.",
  "NO_FORMS_AVAILABLE": "No forms available",
  "FORMS_AVAILABLE_TO_YOUR_ACCOUNT_WILL_APPEAR_HERE": "Forms available to your account will appear here.",
  "NO_FORM_SUBMISSIONS_YET": "No form submissions yet",
  "SUBMITTED_FORMS_WILL_APPEAR_HERE_WHEN_AVAILABLE": "Submitted forms will appear here when available.",
  "THIS_FORM_IS_UNAVAILABLE": "This form is unavailable",
  "CHECK_THE_LINK_OR_ASK_YOUR_CHURCH_FOR_THE_CURRENT_FORM": "Check the link or ask your church for the current form.",
  "NO_NOTES_YET": "No notes yet",
  "NOTES_FOR_THIS_MEMBER_WILL_APPEAR_HERE_WHEN_ADDED": "Notes for this member will appear here when added.",
  "NO_OUTREACH_TASKS_TO_SHOW": "No outreach tasks to show",
  "YOUR_ASSIGNED_OUTREACH_TASKS_WILL_APPEAR_HERE": "Your assigned outreach tasks will appear here.",
  "NO_LINKED_FAMILY_CONTACTS": "No linked family contacts",
  "LINKED_FAMILY_ACCOUNTS_WILL_APPEAR_HERE_WHEN_AVAILABLE": "Linked family accounts will appear here when available.",
  "NO_TAGS_YET": "No tags yet",
  "USE_ADD_TAG_BELOW_TO_ORGANIZE_THIS_MEMBER": "Use Add Tag below to organize this member.",
  "NO_CONTENT_YET": "No content yet",
  "CONTENT_ADDED_TO_THIS_FOLDER_WILL_APPEAR_HERE": "Content added to this folder will appear here.",
  "NO_LINKS_YET": "No links yet",
  "LINKS_ADDED_TO_THIS_SECTION_WILL_APPEAR_HERE": "Links added to this section will appear here.",
  "NO_BIRTHDAYS_MATCH_YOUR_SELECTION": "No birthdays match your selection",
  "TRY_ANOTHER_DATE_RANGE_OR_CHANGE_YOUR_FILTERS": "Try another date range or change your filters.",
  "NO_ATTENDEES_TO_SHOW": "No attendees to show",
  "ATTENDEES_FOR_THIS_EVENT_WILL_APPEAR_HERE_WHEN_AVAILABLE": "Attendees for this event will appear here when available.",
  "NO_VOLUNTEERING_SLOTS_YET": "No volunteering slots yet",
  "SLOTS_WILL_APPEAR_HERE_WHEN_ADDED_TO_THIS_SETUP_SHEET": "Slots will appear here when added to this setup sheet.",
  "NO_EVENTS_MATCH_YOUR_SELECTION": "No events match your selection",
  "TRY_ANOTHER_DATE_OR_CHANGE_YOUR_FILTERS": "Try another date or change your filters.",
  "PLEASE_REVIEW": "Please review",
  "PLEASE_CONFIRM": "Please confirm",
  "GOOD_TO_KNOW": "Good to know",
  "ENTER_A_VALID_EMAIL_ADDRESS": "Enter a valid email address.",
  "PLEASE_SIGN_IN_TO_CONTINUE_TO_CHECK_IN_YOUR_EMAIL_HAS_NOT_BEEN_VERIFIED__3900863": "Please sign in to continue to check-in. Your email has not been verified. No email was sent.",
  "WE_CANNOT_VERIFY_ACCESS_BY_EMAIL_CONTACT_YOUR_CHURCH_FOR_ASSISTANCE": "We cannot verify access by email. Contact your church for assistance.",
  "EMAIL_COULD_NOT_BE_SENT_PLEASE_TRY_AGAIN_SHORTLY": "Email could not be sent. Please try again shortly.",
  "NO_NEW_EMAIL_WAS_SENT_A_RECENT_LINK_MAY_ALREADY_BE_IN_YOUR_INBOX_OR_SPAM": "No new email was sent. A recent link may already be in your inbox or spam folder. Wait one minute between requests; at most five links can be requested per hour.",
  "THIS_LINK_IS_INVALID_OR_EXPIRED_REQUEST_A_NEW_LINK": "This link is invalid or expired. Request a new link.",
  "THIS_LINK_IS_INVALID_EXPIRED_OR_ALREADY_USED_REQUEST_A_NEW_LINK": "This link is invalid, expired, or already used. Request a new link.",
  "THIS_LINK_IS_NO_LONGER_VALID": "This link is no longer valid.",
  "THIS_LINK_HAS_ALREADY_BEEN_USED": "This link has already been used.",
  "THIS_ADDRESS_CANNOT_BE_USED_PLEASE_CHOOSE_ANOTHER_EMAIL": "This address cannot be used. Please choose another email.",
  "UNABLE_TO_UPDATE_YOUR_EMAIL_REQUEST_A_NEW_LINK": "Unable to update your email. Request a new link.",
  "PLEASE_REQUEST_ANOTHER_VERIFICATION_LINK": "Please request another verification link.",
  "WE_COULD_NOT_FIND_AN_ACCOUNT_FOR_THIS_EMAIL_CHECK_THE_ADDRESS_OR_CONTACT": "We could not find an account for this email. Check the address or contact your church.",
  "YOUR_PASSWORD_RESET_EMAIL_WAS_ACCEPTED_FOR_DELIVERY_CHECK_YOUR_INBOX_AND": "Your password-reset email was accepted for delivery. Check your inbox and spam folder.",
  "VERIFY_YOUR_PHONE_BEFORE_RESETTING_YOUR_PASSWORD": "Verify your phone before resetting your password.",
  "UNAUTHORIZED_ACCESS": "UNAUTHORIZED_ACCESS",
  "INVALID_FIRSTNAME_2E708CD": "INVALID_FIRSTNAME",
  "INVALID_LASTNAME_7B89FFE": "INVALID_LASTNAME",
  "INVALID_EMAIL_C1D2FE6": "INVALID_EMAIL",
  "INVALID_MARITALSTATUS_26E6079": "INVALID_MARITALSTATUS",
  "INVALID_DOB_D93D8F2": "INVALID_DOB",
  "INVALID_PHONENUMBER_DCDBA7F": "INVALID_PHONENUMBER",
  "MEMBER_PREVIOUSLY_DEFINED_WITH_DIFFERENT_DOB_6A3BB86": "MEMBER_PREVIOUSLY_DEFINED_WITH_DIFFERENT_DOB",
  "PHONE_EXISTS_FOR_A_DIFFERENT_MEMBER_58001BA": "PHONE_EXISTS_FOR_A_DIFFERENT_MEMBER",
  "EMAIL_EXISTS_FOR_A_DIFFERENT_MEMBER_4287C7B": "EMAIL_EXISTS_FOR_A_DIFFERENT_MEMBER",
  "CANNOT_SAVE_RECORD_9969E85": "CANNOT_SAVE_RECORD",
  "USE_PROFILE_EDITING_TO_CHANGE_THE_ACCOUNT_HOLDER": "Use profile editing to change the account holder.",
  "THIS_CHURCH_USES_EMAIL_VERIFICATION_PLEASE_SIGN_IN_OR_VERIFY_YOUR_EMAIL": "This church uses email verification. Please sign in or verify your email.",
  "SELECT_AN_AVAILABLE_LANGUAGE": "Select an available language.",
  "SELECT_AVAILABLE_LANGUAGES": "Select available languages.",
  "CHOOSE_SMS_OR_EMAIL_VERIFICATION": "Choose SMS or Email verification.",
  "SELECT_AN_AVAILABLE_DEFAULT_LANGUAGE": "Select an available default language.",
  "INVALID_LANGUAGE_SELECTION": "Invalid language selection.",
  "INVALID_PROFILE_FIELD_POLICY": "Invalid profile field policy.",
  "INVALID_STREET_32F84F3": "INVALID_STREET",
  "INVALID_CITY_7E51350": "INVALID_CITY",
  "INVALID_COUNTRY_98BAF88": "INVALID_COUNTRY",
  "INVALID_DIALCODE_D7D79B7": "INVALID_DIALCODE",
  "INVALID_STATE_183C1DA": "INVALID_STATE",
  "INVALID_ZIP_5C06008": "INVALID_ZIP",
  "USER_UPDATED_ECC1712": "USER_UPDATED",
  "ACCOUNT_DELETION_FAILED": "ACCOUNT_DELETION_FAILED",
  "THERE_IS_NO_PENDING_EMAIL_CHANGE": "There is no pending email change.",
  "PLEASE_WAIT_A_MINUTE_BEFORE_REQUESTING_ANOTHER_LINK": "Please wait a minute before requesting another link.",
  "UNABLE_TO_SEND_VERIFICATION_EMAIL_PLEASE_TRY_AGAIN": "Unable to send verification email. Please try again.",
  "WEBHOOK_SECRET_NOT_CONFIGURED": "Webhook secret not configured.",
  "UNSELECTPAGE_23F52E0": "UNSELECTPAGE",
  "SELECTPAGE_9EEB1F6": "SELECTPAGE",
  "UNSELECTALL_F077DC7": "UNSELECTALL",
  "SELECTALL_3D40125": "SELECTALL",
  "SERVICE_VALUE0": "Service: {value0}",
  "DATE_RANGE_VALUE0": "Date Range: {value0}",
  "GROUP_VALUE0": "Group: {value0}",
  "UPLOADING_VALUE0": "Uploading... {value0}%",
  "TO_VALUE0": "to {value0}",
  "ON_VALUE0": "on {value0}",
  "DELETE_VALUE0_THIS_REMOVES_IT_FROM_THE_ACTIVE_GROUP_LIST_YOU_CAN_RESTORE": "Delete “{value0}”? This removes it from the active group list. You can restore it using Show deleted.",
  "RESTORE_VALUE0_TO_THE_ACTIVE_GROUP_LIST": "Restore “{value0}” to the active group list?",
  "AMOUNT_VALUE0": "Amount: {value0}",
  "DATE_VALUE0": "Date: {value0}",
  "PRODUCTION": "Production",
  "VALUE0_PUSHPAY": "{value0} Pushpay",
  "CONNECT_VALUE0": "Connect {value0}",
  "CONNECTED_TO_VALUE0": "Connected to {value0}",
  "LIVE": "Live",
  "RECONNECT": "Reconnect",
  "CONNECT": "Connect",
  "WELCOME_TO_VALUE0": "Welcome to {value0}",
  "SELECT_MINISTRY": "Select ministry",
  "MINISTRY_IS_REQUIRED": "Ministry is required",
  "MINISTRY_VALUE0": "Ministry: {value0}",
  "UNDO_CHECK_IN": "Undo check-in",
  "WELCOME_VALUE0": "Welcome, {value0}!",
  "CHECK_YOUR_EMAIL_TO_ACTIVATE_YOUR_ACCOUNT_BEFORE_SIGNING_IN": "Check your email to activate your account before signing in.",
  "WE_SENT_A_VERIFICATION_LINK_TO": "We sent a verification link to",
  "THE_VERIFICATION_EMAIL_COULD_NOT_BE_SENT_PLEASE_RETRY_BELOW_FOR": "The verification email could not be sent. Please retry below for",
  "UPLOADING_PHOTO": "Uploading photo…",
  "RETRY_PHOTO_UPLOAD": "Retry photo upload",
  "WE_HAVE_SENT_AN_EMAIL_VERIFICATION_LINK_PLEASE_VERIFY_YOUR_EMAIL_TO_KEEP": "We have sent an email verification link. Please verify your email to keep your recovery details up to date.",
  "YOU_CAN_VERIFY_YOUR_EMAIL_LATER_USING_THE_REMINDER_IN_YOUR_ACCOUNT": "You can verify your email later using the reminder in your account.",
  "VALUE0_STEP_VALUE1_OF_5": "{value0} · Step {value1} of 5",
  "START_WITH_YOUR_NAME_AND_PHONE_NUMBER_YOU_WILL_ACTIVATE_YOUR_ACCOUNT_BY_": "Start with your name and phone number. You will activate your account by email.",
  "START_WITH_YOUR_NAME_AND_VERIFY_YOUR_PHONE_SO_YOU_CAN_USE_IT_TO_SIGN_IN": "Start with your name and verify your phone so you can use it to sign in.",
  "A_VALID_EMAIL_ADDRESS_IS_REQUIRED_VERIFY_IT_TO_ACTIVATE_YOUR_ACCOUNT_AND": "A valid email address is required. Verify it to activate your account and recover your password.",
  "YOU_CAN_SIGN_IN_USING_YOUR_VERIFIED_PHONE_NUMBER_AND_PASSWORD_EMAIL_CAN_": "You can sign in using your verified phone number and password. Email can be verified later.",
  "VALUE0_REQUIRED": "{value0} Required",
  "EMAIL_VALUE0": "Email: {value0}",
  "NOT_PROVIDED": "Not provided",
  "VALUE0_SIGN_IN_OR_RESET_YOUR_PASSWORD_IF_YOU_NEED_HELP_ACCESSING_IT": "{value0} Sign in, or reset your password if you need help accessing it.",
  "TR_VALUE0": "TR-{value0}",
  "VALUE0_YOU_RE_INVITED_TO_JOIN": "{value0}, you're invited to join",
  "PERSON": "person",
  "PEOPLE": "People",
  "COLLAPSE_MONTH": "Collapse month",
  "SHOW_MONTH": "Show month",
  "EVENT": "event",
  "EVENTS_862417B": "events",
  "SEND_VALUE0_VALUE1": "Send {value0} {value1}",
  "FIND_MATCHES": "Find matches",
  "CURRENT_MEMBERS": "Current members",
  "LESS_5DCCB84": "LESS",
  "MORE_036A27C": "MORE",
  "VALUE0_ACTIVE": "{value0} active",
  "ACCOUNT_DETAILS_HOUSEHOLD": "Account details & household",
  "DATE_OF_BIRTH_NOT_PROVIDED": "Date of birth not provided",
  "YOU_CAN_MANAGE_THIS_ACCOUNT_AND_ITS_HOUSEHOLD_MEMBERS_HERE": "You can manage this account and its household members here.",
  "YOU_CAN_UPDATE_YOUR_HOUSEHOLD_ANYTIME_IN_MY_PROFILE": "You can update your household anytime in My Profile.",
  "VALUE0_VALUE1_ON_VALUE2": "{value0} {value1} on {value2}",
  "VERIFIED": "Verified",
  "NOT_VERIFIED": "Not verified",
  "SENDING": "Sending…",
  "LINK_SENT": "Link sent",
  "SEND_VERIFICATION_EMAIL": "Send verification email",
  "ALL_VALUE0": "All {value0}",
  "TASK_4BC74B2": "Task",
  "SERVICES_EVENTS": "Services & events",
  "PLATFORM_ADMIN": "Platform admin",
  "GROUP_MANAGEMENT": "Group management",
  "PEOPLE_ACCESS": "People & access",
  "GIVING_PAYMENTS": "Giving & payments",
  "DATA_LINKS": "Data & links",
  "DISCARD": "Discard",
  "EVENT_COUNT_ONE": "{count} event",
  "EVENT_COUNT_OTHER": "{count} events",
  "EVENT_COUNT_ZERO": "{count} events",
  "EVENT_COUNT_TWO": "{count} events",
  "EVENT_COUNT_FEW": "{count} events",
  "EVENT_COUNT_MANY": "{count} events",
  "THE_SELECTED_IMAGE_COULD_NOT_BE_PROCESSED_PLEASE_TRY_ANOTHER_IMAGE": "The selected image could not be processed. Please try another image.",
  "TOP_20": "top: 20%",
  "TOP_50": "top: 50%",
  "TOP_80": "top: 80%",
  "NAME_CANNOT_BE_EMPTY": "Name cannot be empty!",
  "FAS_FA_LINK": "fas fa-link",
  "FAS_FA_FOLDER": "fas fa-folder",
  "FAS_FA_FILE_ALT": "fas fa-file-alt",
  "FAS_FA_CALENDAR_ALT": "fas fa-calendar-alt",
  "FAS_FA_FOLDER_OPEN": "fas fa-folder-open",
  "FAS_FA_MAP_MARKER_ALT": "fas fa-map-marker-alt",
  "FAS_FA_FILE": "fas fa-file",
  "FAS_FA_IMAGE": "fas fa-image",
  "FAS_FA_VIDEO": "fas fa-video",
  "FAS_FA_MUSIC": "fas fa-music",
  "FAS_FA_VALUE0": "fas fa-{value0}",
  "THIS_WILL_DELETE_VALUE0_RECORDS_ARE_YOU_SURE_YOU_WANT_TO_PROCEED": "This will delete ({value0}) records. Are you sure you want to proceed?",
  "ARE_YOU_SURE_YOU_WANT_TO_CREATE_ALL_RECORDS": "Are you sure you want to create all records?",
  "ARE_YOU_SURE_YOU_WANT_TO_CREATE_ALL_EVENTS": "Are you sure you want to create all events?",
  "THIS_ACTION_WILL_UNREGISTER_VALUE0_IN_ORDER_TO_REGISTER_ANOTHER_PERSON_A": "This action will unregister {value0} in order to register another person. Are you sure you would like to proceed?",
  "YOUR_NAME_AND_PHONE": "Your name and phone",
  "REVIEW_AND_CREATE": "Review and create",
  "SELECTED_NOTIFICATIONS_VALUE0_VALUE1": "Selected Notifications:  {value0}/{value1}",
  "OPERATION_HAS_COMPLETED_SUCCESSFULLY": "Operation has completed successfully!",
  "NO_NAMES_FOUND": "No Names Found!",
  "YOUR_SESSION_HAS_EXPIRED_PLEASE_SIGN_IN_AGAIN": "Your session has expired. Please sign in again.",
  "YOU_DO_NOT_HAVE_PERMISSION_TO_SEARCH_THESE_MEMBERS": "You do not have permission to search these members.",
  "UNABLE_TO_CONNECT_TO_THE_SERVER_PLEASE_TRY_AGAIN_SHORTLY": "Unable to connect to the server. Please try again shortly.",
  "UNABLE_TO_LOAD_MEMBERS_RIGHT_NOW_PLEASE_TRY_AGAIN_SHORTLY": "Unable to load members right now. Please try again shortly.",
  "PERSONAL_DETAILS": "Personal details",
  "CONTACT_PREFERENCES": "Contact & preferences",
  "VALUE0_PAYMENTADAPTER_VALUE1_VALUE2_AUTHORIZE_TENANT_VALUE3": "{value0}/PaymentAdapter/{value1}/{value2}Authorize?tenant={value3}",
  "RECORD_VISIT": "Record Visit",
  "RECORD_CALL": "Record Call",
  "RECORD_TEXT": "Record Text",
  "RECORD_EMAIL": "Record Email",
  "RECORD": "Record",
  "SELECT_ASSIGNEES": "Select Assignees",
  "PAGENUMBER": "pageNumber",
  "TOTALPAGES": "totalPages",
  "DESELECT": "Deselect",
  "COLLAPSE_ACTIONS_FOR": "Collapse actions for",
  "EXPAND_ACTIONS_FOR": "Expand actions for",
  "SELECT_VALUE0": "Select {value0}",
  "MEMBER_TOOLS_FOR_VALUE0": "Member tools for {value0}",
  "DETAILS_FOR_VALUE0": "Details for {value0}",
  "SELECT_RECIPIENTS": "Select Recipients",
  "SELECT_APPROVERS": "Select Approvers",
  "ISLEADER": "isLeader",
  "COLLAPSE_TOOLS_FOR": "Collapse tools for",
  "EXPAND_TOOLS_FOR": "Expand tools for",
  "RESTORE_GROUP": "Restore group",
  "DELETE_GROUP": "Delete group",
  "CONFIRM_GROUP_VISIBILITY_CHANGE": "Confirm group visibility change",
  "EDIT_PERMISSIONS_FOR_VALUE0": "Edit permissions for {value0}",
  "SELECT_LEADERS_73012DB": "Select Leaders",
  "RESTORE_SERVICE": "Restore service",
  "DELETE_SERVICE": "Delete service",
  "YOUR_ACCOUNT_WITH_VALUE0_IS_READY": "Your account with {value0} is ready.",
  "STEP_VALUE0_OF_5": "Step {value0} of 5",
  "AN_ACCOUNT_ALREADY_EXISTS": "An account already exists",
  "YOUR_ACCOUNT_COULD_NOT_BE_CREATED": "Your account could not be created",
  "SYSTEM_BBC5E66": "system",
  "LANGUAGE": "language",
  "VALUE0_TASKS": "{value0} tasks",
  "VALUE0_ACCOUNT_MENU": "{value0}, account menu",
  "SIGN_IN_AND_ACCOUNT_MENU": "Sign in and account menu",
  "TRUE": "true",
  "ASSIGNERCOMMENT": "assignerComment",
  "TOOLS_FOR_VALUE0": "Tools for {value0}",
  "MANAGE_EVENTS": "Manage events",
  "AUTO_MODE": "Automatic mode",
  "REQUIRES_APPROVAL": "Requires approval",
  "SERVICE_CHECKINQR": "Service check-in QR code",
  "ALTAR_PRAYERS": "Altar prayers",
  "PERSONAL_NOTIFICATION": "Personal notification",
  "LEADERSHIP_SELECTION_REQUIRED": "Select at least one person before assigning leadership.",
  "LEADERSHIP_MEMBERS_ONLY": "Guests cannot be assigned leadership. Change their church membership to Member first.",
  "LEADERSHIP_PRIMARY_ACCOUNT_REQUIRED": "Leadership requires the selected person to have their own account as its primary member. A household profile without its own account cannot be assigned leadership.",
  "PERMISSION_MEMBERS_ONLY": "Guests can only have the Base permission. Change their church membership to Member before assigning other permissions.",
  "CONFIRM_ADD_LEADERSHIP": "Assign leadership to {count} selected member(s)?",
  "CONFIRM_REMOVE_LEADERSHIP": "Remove leadership from {count} selected member(s)?",
  "UNREAD": "Unread",
  "ALL_CAUGHT_UP": "All notifications read",
  "NO_UNREAD_NOTIFICATIONS": "You have no unread notifications.",
  "COMPOSE_MESSAGE": "Compose a message",
  "MESSAGE_EDITOR_HINT": "Add your message, links, and images when you’re ready.",
  "MESSAGE_REVIEW": "Review and send",
  "EDIT_MESSAGE": "Edit message",
  "SEND_TEST": "Send to myself",
  "TEST_MESSAGE_SENT": "Your test message has been sent to you. You can still send this message to your recipients.",
  "MESSAGE_SEND_FAILED": "We couldn’t confirm that your message was sent. Check before sending again to avoid duplicates.",
  "MESSAGE_SUBJECT_REQUIRED": "Please enter a subject or title before sending.",
  "MESSAGE_SCHEDULE_INVALID": "Choose a future date and time for scheduled delivery.",
  "CHARACTERS": "characters",
  "ESTIMATED_TEXTS": "estimated texts per recipient",
  "MESSAGE_PREVIEW_NOTE": "Preview only. Personalization tags are filled in when sent; appearance may vary by device.",
  "ATTACH_FILES": "Attach a file",
  "TEXT_ATTACHMENT_UNSUPPORTED": "This file type is not supported for text messages.",
  "TEXT_ATTACHMENT_TOO_LARGE": "Text message attachments must be {size} KB or smaller.",
  "ATTACHMENT_UPLOAD_FAILED": "The file could not be attached. Please try again."
}
